import { AMemberInfo, defaultAMemberInfo } from "../internalModules";

const updateData = (data: AMemberInfo, updatedFields: Partial<AMemberInfo>) => ({
  ...data,
  ...updatedFields,
})

export function getMemberShapeData(kindFilter = ''): AMemberInfo[] {
  const allMemberData = wideFlangeData.concat(
    solidRectangularData,
    hollowRectangularData,
    hollowRectangularHSSData,
    coldFormedData,
    metalDeckData,
    rebarData,
    roundHollowHSSData,
    zeeData,
  )
  let memberData = Array.from(allMemberData).map( x => updateData(defaultAMemberInfo, x))
  if(kindFilter.length > 0){
    memberData = memberData.filter( x => x.kind === kindFilter)
  }
  return memberData
}

export function getMemberShapeInfo(name: string, kindFilter = ''): AMemberInfo{
  let info : AMemberInfo
  const memberData = getMemberShapeData(kindFilter).find(x=>x.name === name)
  if(memberData){
    info = memberData
  }
  else{
    info = getMemberShapeData(kindFilter)[0]
  }
  if(info){
    return info
  }
  return defaultAMemberInfo
}

const wideFlangeData: Partial<AMemberInfo>[] = [
  {
    "kind": "Wide Flange",
    "materialGuid": "f88c011a-99c9-43a6-82bb-5aed2c3af067",
    "name": "Wood I-Joist 1.75\" x 9.5\"",
    "depth": 9.5,
    "width": 1.75,
    "flangeThickness": 1.5,
    "webThickness": 0.375
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "f88c011a-99c9-43a6-82bb-5aed2c3af067",
    "name": "Wood I-Joist 1.75\" x 11.875\"",
    "depth": 11.875,
    "width": 1.75,
    "flangeThickness": 1.5,
    "webThickness": 0.375
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "f88c011a-99c9-43a6-82bb-5aed2c3af067",
    "name": "Wood I-Joist 1.75\" x 14\"",
    "depth": 14,
    "width": 1.75,
    "flangeThickness": 1.5,
    "webThickness": 0.375
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "f88c011a-99c9-43a6-82bb-5aed2c3af067",
    "name": "Wood I-Joist 2.5\" x 11.875\"",
    "depth": 11.875,
    "width": 2.5,
    "flangeThickness": 1.5,
    "webThickness": 0.438
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "f88c011a-99c9-43a6-82bb-5aed2c3af067",
    "name": "Wood I-Joist 2.5\" x 14\"",
    "depth": 14,
    "width": 2.5,
    "flangeThickness": 1.5,
    "webThickness": 0.438
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "f88c011a-99c9-43a6-82bb-5aed2c3af067",
    "name": "Wood I-Joist 3.5\" x 11.875\"",
    "depth": 11.875,
    "width": 3.5,
    "flangeThickness": 1.5,
    "webThickness": 0.438
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "f88c011a-99c9-43a6-82bb-5aed2c3af067",
    "name": "Wood I-Joist 3.5\" x 14\"",
    "depth": 14,
    "width": 3.5,
    "flangeThickness": 1.5,
    "webThickness": 0.438
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W44x335",
    "depth": 44,
    "width": 15.9,
    "flangeThickness": 1.77,
    "webThickness": 1.03,
    "area": 98.5,
    "weight": 335
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W44x290",
    "depth": 43.6,
    "width": 15.8,
    "flangeThickness": 1.58,
    "webThickness": 0.865,
    "area": 85.4,
    "weight": 290
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W44x262",
    "depth": 43.3,
    "width": 15.8,
    "flangeThickness": 1.42,
    "webThickness": 0.785,
    "area": 76.9,
    "weight": 262
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W44x230",
    "depth": 42.9,
    "width": 15.8,
    "flangeThickness": 1.22,
    "webThickness": 0.71,
    "area": 67.7,
    "weight": 230
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x593",
    "depth": 43,
    "width": 16.7,
    "flangeThickness": 3.23,
    "webThickness": 1.79,
    "area": 174,
    "weight": 593
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x503",
    "depth": 42.1,
    "width": 16.4,
    "flangeThickness": 2.76,
    "webThickness": 1.54,
    "area": 148,
    "weight": 503
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x431",
    "depth": 41.3,
    "width": 16.2,
    "flangeThickness": 2.36,
    "webThickness": 1.34,
    "area": 127,
    "weight": 431
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x397",
    "depth": 41,
    "width": 16.1,
    "flangeThickness": 2.2,
    "webThickness": 1.22,
    "area": 117,
    "weight": 397
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x372",
    "depth": 40.6,
    "width": 16.1,
    "flangeThickness": 2.05,
    "webThickness": 1.16,
    "area": 109,
    "weight": 372
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x362",
    "depth": 40.6,
    "width": 16,
    "flangeThickness": 2.01,
    "webThickness": 1.12,
    "area": 107,
    "weight": 362
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x324",
    "depth": 40.2,
    "width": 15.9,
    "flangeThickness": 1.81,
    "webThickness": 1,
    "area": 95.3,
    "weight": 324
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x297",
    "depth": 39.8,
    "width": 15.8,
    "flangeThickness": 1.65,
    "webThickness": 0.93,
    "area": 87.4,
    "weight": 297
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x277",
    "depth": 39.7,
    "width": 15.8,
    "flangeThickness": 1.58,
    "webThickness": 0.83,
    "area": 81.4,
    "weight": 277
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x249",
    "depth": 39.4,
    "width": 15.8,
    "flangeThickness": 1.42,
    "webThickness": 0.75,
    "area": 73.3,
    "weight": 249
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x215",
    "depth": 39,
    "width": 15.8,
    "flangeThickness": 1.22,
    "webThickness": 0.65,
    "area": 63.4,
    "weight": 215
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x199",
    "depth": 38.7,
    "width": 15.8,
    "flangeThickness": 1.07,
    "webThickness": 0.65,
    "area": 58.5,
    "weight": 199
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x392",
    "depth": 41.6,
    "width": 12.4,
    "flangeThickness": 2.52,
    "webThickness": 1.42,
    "area": 115,
    "weight": 392
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x331",
    "depth": 40.8,
    "width": 12.2,
    "flangeThickness": 2.13,
    "webThickness": 1.22,
    "area": 97.5,
    "weight": 331
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x327",
    "depth": 40.8,
    "width": 12.1,
    "flangeThickness": 2.13,
    "webThickness": 1.18,
    "area": 96,
    "weight": 327
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x294",
    "depth": 40.4,
    "width": 12,
    "flangeThickness": 1.93,
    "webThickness": 1.06,
    "area": 86.3,
    "weight": 294
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x278",
    "depth": 40.2,
    "width": 12,
    "flangeThickness": 1.81,
    "webThickness": 1.03,
    "area": 82,
    "weight": 278
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x264",
    "depth": 40,
    "width": 11.9,
    "flangeThickness": 1.73,
    "webThickness": 0.96,
    "area": 77.6,
    "weight": 264
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x235",
    "depth": 39.7,
    "width": 11.9,
    "flangeThickness": 1.58,
    "webThickness": 0.83,
    "area": 69,
    "weight": 235
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x211",
    "depth": 39.4,
    "width": 11.8,
    "flangeThickness": 1.42,
    "webThickness": 0.75,
    "area": 62,
    "weight": 211
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x183",
    "depth": 39,
    "width": 11.8,
    "flangeThickness": 1.2,
    "webThickness": 0.65,
    "area": 53.3,
    "weight": 183
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x167",
    "depth": 38.6,
    "width": 11.8,
    "flangeThickness": 1.03,
    "webThickness": 0.65,
    "area": 49.2,
    "weight": 167
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W40x149",
    "depth": 38.2,
    "width": 11.8,
    "flangeThickness": 0.83,
    "webThickness": 0.63,
    "area": 43.8,
    "weight": 149
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x800",
    "depth": 42.6,
    "width": 18,
    "flangeThickness": 4.29,
    "webThickness": 2.38,
    "area": 236,
    "weight": 800
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x652",
    "depth": 41.1,
    "width": 17.6,
    "flangeThickness": 3.54,
    "webThickness": 1.97,
    "area": 192,
    "weight": 652
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x529",
    "depth": 39.8,
    "width": 17.2,
    "flangeThickness": 2.91,
    "webThickness": 1.61,
    "area": 156,
    "weight": 529
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x487",
    "depth": 39.3,
    "width": 17.1,
    "flangeThickness": 2.68,
    "webThickness": 1.5,
    "area": 143,
    "weight": 487
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x441",
    "depth": 38.9,
    "width": 17,
    "flangeThickness": 2.44,
    "webThickness": 1.36,
    "area": 130,
    "weight": 442
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x395",
    "depth": 38.4,
    "width": 16.8,
    "flangeThickness": 2.2,
    "webThickness": 1.22,
    "area": 116,
    "weight": 395
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x361",
    "depth": 38,
    "width": 16.7,
    "flangeThickness": 2.01,
    "webThickness": 1.12,
    "area": 106,
    "weight": 361
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x330",
    "depth": 37.7,
    "width": 16.6,
    "flangeThickness": 1.85,
    "webThickness": 1.02,
    "area": 97,
    "weight": 330
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x302",
    "depth": 37.3,
    "width": 16.7,
    "flangeThickness": 1.68,
    "webThickness": 0.945,
    "area": 88.8,
    "weight": 302
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x282",
    "depth": 37.1,
    "width": 16.6,
    "flangeThickness": 1.57,
    "webThickness": 0.885,
    "area": 82.9,
    "weight": 282
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x262",
    "depth": 36.9,
    "width": 16.6,
    "flangeThickness": 1.44,
    "webThickness": 0.84,
    "area": 77,
    "weight": 262
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x247",
    "depth": 36.7,
    "width": 16.5,
    "flangeThickness": 1.35,
    "webThickness": 0.8,
    "area": 72.5,
    "weight": 247
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x231",
    "depth": 36.5,
    "width": 16.5,
    "flangeThickness": 1.26,
    "webThickness": 0.76,
    "area": 68.1,
    "weight": 230
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x256",
    "depth": 37.4,
    "width": 12.2,
    "flangeThickness": 1.73,
    "webThickness": 0.96,
    "area": 75.4,
    "weight": 256
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x232",
    "depth": 37.1,
    "width": 12.1,
    "flangeThickness": 1.57,
    "webThickness": 0.87,
    "area": 68.1,
    "weight": 232
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x210",
    "depth": 36.7,
    "width": 12.2,
    "flangeThickness": 1.36,
    "webThickness": 0.83,
    "area": 61.8,
    "weight": 210
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x194",
    "depth": 36.5,
    "width": 12.1,
    "flangeThickness": 1.26,
    "webThickness": 0.765,
    "area": 57,
    "weight": 194
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x182",
    "depth": 36.3,
    "width": 12.1,
    "flangeThickness": 1.18,
    "webThickness": 0.725,
    "area": 53.6,
    "weight": 182
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x170",
    "depth": 36.2,
    "width": 12,
    "flangeThickness": 1.1,
    "webThickness": 0.68,
    "area": 50.1,
    "weight": 170
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x160",
    "depth": 36,
    "width": 12,
    "flangeThickness": 1.02,
    "webThickness": 0.65,
    "area": 47,
    "weight": 160
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x150",
    "depth": 35.9,
    "width": 12,
    "flangeThickness": 0.94,
    "webThickness": 0.625,
    "area": 44.2,
    "weight": 150
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W36x135",
    "depth": 35.6,
    "width": 12,
    "flangeThickness": 0.79,
    "webThickness": 0.6,
    "area": 39.7,
    "weight": 135
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W33x387",
    "depth": 36,
    "width": 16.2,
    "flangeThickness": 2.28,
    "webThickness": 1.26,
    "area": 114,
    "weight": 387
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W33x354",
    "depth": 35.6,
    "width": 16.1,
    "flangeThickness": 2.09,
    "webThickness": 1.16,
    "area": 104,
    "weight": 354
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W33x318",
    "depth": 35.2,
    "width": 16,
    "flangeThickness": 1.89,
    "webThickness": 1.04,
    "area": 93.6,
    "weight": 318
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W33x291",
    "depth": 34.8,
    "width": 15.9,
    "flangeThickness": 1.73,
    "webThickness": 0.96,
    "area": 85.7,
    "weight": 291
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W33x263",
    "depth": 34.5,
    "width": 15.8,
    "flangeThickness": 1.57,
    "webThickness": 0.87,
    "area": 77.5,
    "weight": 263
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W33x241",
    "depth": 34.2,
    "width": 15.9,
    "flangeThickness": 1.4,
    "webThickness": 0.83,
    "area": 71,
    "weight": 241
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W33x221",
    "depth": 33.9,
    "width": 15.8,
    "flangeThickness": 1.28,
    "webThickness": 0.775,
    "area": 65.2,
    "weight": 221
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W33x201",
    "depth": 33.7,
    "width": 15.7,
    "flangeThickness": 1.15,
    "webThickness": 0.715,
    "area": 59.2,
    "weight": 201
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W33x169",
    "depth": 33.8,
    "width": 11.5,
    "flangeThickness": 1.22,
    "webThickness": 0.67,
    "area": 49.5,
    "weight": 169
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W33x152",
    "depth": 33.5,
    "width": 11.6,
    "flangeThickness": 1.06,
    "webThickness": 0.635,
    "area": 44.8,
    "weight": 152
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W33x141",
    "depth": 33.3,
    "width": 11.5,
    "flangeThickness": 0.96,
    "webThickness": 0.605,
    "area": 41.6,
    "weight": 141
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W33x130",
    "depth": 33.1,
    "width": 11.5,
    "flangeThickness": 0.855,
    "webThickness": 0.58,
    "area": 38.3,
    "weight": 130
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W33x118",
    "depth": 32.9,
    "width": 11.5,
    "flangeThickness": 0.74,
    "webThickness": 0.55,
    "area": 34.7,
    "weight": 118
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W30x391",
    "depth": 33.2,
    "width": 15.6,
    "flangeThickness": 2.44,
    "webThickness": 1.36,
    "area": 115,
    "weight": 391
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W30x357",
    "depth": 32.8,
    "width": 15.5,
    "flangeThickness": 2.24,
    "webThickness": 1.24,
    "area": 105,
    "weight": 357
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W30x326",
    "depth": 32.4,
    "width": 15.4,
    "flangeThickness": 2.05,
    "webThickness": 1.14,
    "area": 95.8,
    "weight": 326
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W30x292",
    "depth": 32,
    "width": 15.3,
    "flangeThickness": 1.85,
    "webThickness": 1.02,
    "area": 85.9,
    "weight": 292
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W30x261",
    "depth": 31.6,
    "width": 15.2,
    "flangeThickness": 1.65,
    "webThickness": 0.93,
    "area": 76.9,
    "weight": 261
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W30x235",
    "depth": 31.3,
    "width": 15.1,
    "flangeThickness": 1.5,
    "webThickness": 0.83,
    "area": 69.2,
    "weight": 235
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W30x211",
    "depth": 30.9,
    "width": 15.1,
    "flangeThickness": 1.32,
    "webThickness": 0.775,
    "area": 62.2,
    "weight": 211
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W30x191",
    "depth": 30.7,
    "width": 15,
    "flangeThickness": 1.19,
    "webThickness": 0.71,
    "area": 56.3,
    "weight": 191
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W30x173",
    "depth": 30.4,
    "width": 15,
    "flangeThickness": 1.07,
    "webThickness": 0.655,
    "area": 51,
    "weight": 173
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W30x148",
    "depth": 30.7,
    "width": 10.5,
    "flangeThickness": 1.18,
    "webThickness": 0.65,
    "area": 43.5,
    "weight": 148
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W30x132",
    "depth": 30.3,
    "width": 10.5,
    "flangeThickness": 1,
    "webThickness": 0.615,
    "area": 38.9,
    "weight": 132
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W30x124",
    "depth": 30.2,
    "width": 10.5,
    "flangeThickness": 0.93,
    "webThickness": 0.585,
    "area": 36.5,
    "weight": 124
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W30x116",
    "depth": 30,
    "width": 10.5,
    "flangeThickness": 0.85,
    "webThickness": 0.565,
    "area": 34.2,
    "weight": 116
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W30x108",
    "depth": 29.8,
    "width": 10.5,
    "flangeThickness": 0.76,
    "webThickness": 0.545,
    "area": 31.7,
    "weight": 108
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W30x99",
    "depth": 29.7,
    "width": 10.5,
    "flangeThickness": 0.67,
    "webThickness": 0.52,
    "area": 29.1,
    "weight": 99
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W30x90",
    "depth": 29.5,
    "width": 10.4,
    "flangeThickness": 0.61,
    "webThickness": 0.47,
    "area": 26.4,
    "weight": 90
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W27x539",
    "depth": 32.5,
    "width": 15.3,
    "flangeThickness": 3.54,
    "webThickness": 1.97,
    "area": 159,
    "weight": 539
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W27x368",
    "depth": 30.4,
    "width": 14.7,
    "flangeThickness": 2.48,
    "webThickness": 1.38,
    "area": 108,
    "weight": 368
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W27x336",
    "depth": 30,
    "width": 14.6,
    "flangeThickness": 2.28,
    "webThickness": 1.26,
    "area": 98.9,
    "weight": 336
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W27x307",
    "depth": 29.6,
    "width": 14.4,
    "flangeThickness": 2.09,
    "webThickness": 1.16,
    "area": 90.4,
    "weight": 307
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W27x281",
    "depth": 29.3,
    "width": 14.4,
    "flangeThickness": 1.93,
    "webThickness": 1.06,
    "area": 82.9,
    "weight": 281
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W27x258",
    "depth": 29,
    "width": 14.3,
    "flangeThickness": 1.77,
    "webThickness": 0.98,
    "area": 76,
    "weight": 258
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W27x235",
    "depth": 28.7,
    "width": 14.2,
    "flangeThickness": 1.61,
    "webThickness": 0.91,
    "area": 69.4,
    "weight": 235
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W27x217",
    "depth": 28.4,
    "width": 14.1,
    "flangeThickness": 1.5,
    "webThickness": 0.83,
    "area": 64,
    "weight": 217
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W27x194",
    "depth": 28.1,
    "width": 14,
    "flangeThickness": 1.34,
    "webThickness": 0.75,
    "area": 57.2,
    "weight": 194
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W27x178",
    "depth": 27.8,
    "width": 14.1,
    "flangeThickness": 1.19,
    "webThickness": 0.725,
    "area": 52.5,
    "weight": 178
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W27x161",
    "depth": 27.6,
    "width": 14,
    "flangeThickness": 1.08,
    "webThickness": 0.66,
    "area": 47.6,
    "weight": 161
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W27x146",
    "depth": 27.4,
    "width": 14,
    "flangeThickness": 0.975,
    "webThickness": 0.605,
    "area": 43.1,
    "weight": 146
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W27x129",
    "depth": 27.6,
    "width": 10,
    "flangeThickness": 1.1,
    "webThickness": 0.61,
    "area": 37.8,
    "weight": 129
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W27x114",
    "depth": 27.3,
    "width": 10.1,
    "flangeThickness": 0.93,
    "webThickness": 0.57,
    "area": 33.5,
    "weight": 114
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W27x102",
    "depth": 27.1,
    "width": 10,
    "flangeThickness": 0.83,
    "webThickness": 0.515,
    "area": 30,
    "weight": 102
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W27x94",
    "depth": 26.9,
    "width": 10,
    "flangeThickness": 0.745,
    "webThickness": 0.49,
    "area": 27.7,
    "weight": 94
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W27x84",
    "depth": 26.7,
    "width": 10,
    "flangeThickness": 0.64,
    "webThickness": 0.46,
    "area": 24.8,
    "weight": 84
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x370",
    "depth": 28,
    "width": 13.7,
    "flangeThickness": 2.72,
    "webThickness": 1.52,
    "area": 109,
    "weight": 370
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x335",
    "depth": 27.5,
    "width": 13.5,
    "flangeThickness": 2.48,
    "webThickness": 1.38,
    "area": 98.4,
    "weight": 335
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x306",
    "depth": 27.1,
    "width": 13.4,
    "flangeThickness": 2.28,
    "webThickness": 1.26,
    "area": 89.8,
    "weight": 306
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x279",
    "depth": 26.7,
    "width": 13.3,
    "flangeThickness": 2.09,
    "webThickness": 1.16,
    "area": 82,
    "weight": 279
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x250",
    "depth": 26.3,
    "width": 13.2,
    "flangeThickness": 1.89,
    "webThickness": 1.04,
    "area": 73.5,
    "weight": 250
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x229",
    "depth": 26,
    "width": 13.1,
    "flangeThickness": 1.73,
    "webThickness": 0.96,
    "area": 67.2,
    "weight": 229
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x207",
    "depth": 25.7,
    "width": 13,
    "flangeThickness": 1.57,
    "webThickness": 0.87,
    "area": 60.7,
    "weight": 207
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x192",
    "depth": 25.5,
    "width": 13,
    "flangeThickness": 1.46,
    "webThickness": 0.81,
    "area": 56.3,
    "weight": 192
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x176",
    "depth": 25.2,
    "width": 12.9,
    "flangeThickness": 1.34,
    "webThickness": 0.75,
    "area": 51.7,
    "weight": 176
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x162",
    "depth": 25,
    "width": 13,
    "flangeThickness": 1.22,
    "webThickness": 0.705,
    "area": 47.7,
    "weight": 162
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x146",
    "depth": 24.7,
    "width": 12.9,
    "flangeThickness": 1.09,
    "webThickness": 0.65,
    "area": 43,
    "weight": 146
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x131",
    "depth": 24.5,
    "width": 12.9,
    "flangeThickness": 0.96,
    "webThickness": 0.605,
    "area": 38.5,
    "weight": 131
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x117",
    "depth": 24.3,
    "width": 12.8,
    "flangeThickness": 0.85,
    "webThickness": 0.55,
    "area": 34.4,
    "weight": 117
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x104",
    "depth": 24.1,
    "width": 12.8,
    "flangeThickness": 0.75,
    "webThickness": 0.5,
    "area": 30.6,
    "weight": 104
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x103",
    "depth": 24.5,
    "width": 9,
    "flangeThickness": 0.98,
    "webThickness": 0.55,
    "area": 30.3,
    "weight": 103
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x94",
    "depth": 24.3,
    "width": 9.07,
    "flangeThickness": 0.875,
    "webThickness": 0.515,
    "area": 27.7,
    "weight": 94
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x84",
    "depth": 24.1,
    "width": 9.02,
    "flangeThickness": 0.77,
    "webThickness": 0.47,
    "area": 24.7,
    "weight": 84
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x76",
    "depth": 23.9,
    "width": 8.99,
    "flangeThickness": 0.68,
    "webThickness": 0.44,
    "area": 22.4,
    "weight": 76
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x68",
    "depth": 23.7,
    "width": 8.97,
    "flangeThickness": 0.585,
    "webThickness": 0.415,
    "area": 20.1,
    "weight": 68
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x62",
    "depth": 23.7,
    "width": 7.04,
    "flangeThickness": 0.59,
    "webThickness": 0.43,
    "area": 18.2,
    "weight": 62
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W24x55",
    "depth": 23.6,
    "width": 7.01,
    "flangeThickness": 0.505,
    "webThickness": 0.395,
    "area": 16.2,
    "weight": 55
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W21x201",
    "depth": 23,
    "width": 12.6,
    "flangeThickness": 1.63,
    "webThickness": 0.91,
    "area": 59.2,
    "weight": 201
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W21x182",
    "depth": 22.7,
    "width": 12.5,
    "flangeThickness": 1.48,
    "webThickness": 0.83,
    "area": 53.6,
    "weight": 182
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W21x166",
    "depth": 22.5,
    "width": 12.4,
    "flangeThickness": 1.36,
    "webThickness": 0.75,
    "area": 48.8,
    "weight": 166
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W21x147",
    "depth": 22.1,
    "width": 12.5,
    "flangeThickness": 1.15,
    "webThickness": 0.72,
    "area": 43.2,
    "weight": 147
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W21x132",
    "depth": 21.8,
    "width": 12.4,
    "flangeThickness": 1.04,
    "webThickness": 0.65,
    "area": 38.8,
    "weight": 132
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W21x122",
    "depth": 21.7,
    "width": 12.4,
    "flangeThickness": 0.96,
    "webThickness": 0.6,
    "area": 35.9,
    "weight": 122
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W21x111",
    "depth": 21.5,
    "width": 12.3,
    "flangeThickness": 0.875,
    "webThickness": 0.55,
    "area": 32.7,
    "weight": 111
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W21x101",
    "depth": 21.4,
    "width": 12.3,
    "flangeThickness": 0.8,
    "webThickness": 0.5,
    "area": 29.8,
    "weight": 101
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W21x93",
    "depth": 21.6,
    "width": 8.42,
    "flangeThickness": 0.93,
    "webThickness": 0.58,
    "area": 27.3,
    "weight": 93
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W21x83",
    "depth": 21.4,
    "width": 8.36,
    "flangeThickness": 0.835,
    "webThickness": 0.515,
    "area": 24.3,
    "weight": 83
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W21x73",
    "depth": 21.2,
    "width": 8.3,
    "flangeThickness": 0.74,
    "webThickness": 0.455,
    "area": 21.5,
    "weight": 73
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W21x68",
    "depth": 21.1,
    "width": 8.27,
    "flangeThickness": 0.685,
    "webThickness": 0.43,
    "area": 20,
    "weight": 68
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W21x62",
    "depth": 21,
    "width": 8.24,
    "flangeThickness": 0.615,
    "webThickness": 0.4,
    "area": 18.3,
    "weight": 62
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W21x55",
    "depth": 20.8,
    "width": 8.22,
    "flangeThickness": 0.522,
    "webThickness": 0.375,
    "area": 16.2,
    "weight": 55
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W21x48",
    "depth": 20.6,
    "width": 8.14,
    "flangeThickness": 0.43,
    "webThickness": 0.35,
    "area": 14.1,
    "weight": 48
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W21x57",
    "depth": 21.1,
    "width": 6.56,
    "flangeThickness": 0.65,
    "webThickness": 0.405,
    "area": 16.7,
    "weight": 57
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W21x50",
    "depth": 20.8,
    "width": 6.53,
    "flangeThickness": 0.535,
    "webThickness": 0.38,
    "area": 14.7,
    "weight": 50
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W21x44",
    "depth": 20.7,
    "width": 6.5,
    "flangeThickness": 0.45,
    "webThickness": 0.35,
    "area": 13,
    "weight": 44
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x311",
    "depth": 22.3,
    "width": 12,
    "flangeThickness": 2.74,
    "webThickness": 1.52,
    "area": 91.6,
    "weight": 311
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x283",
    "depth": 21.9,
    "width": 11.9,
    "flangeThickness": 2.5,
    "webThickness": 1.4,
    "area": 83.3,
    "weight": 283
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x258",
    "depth": 21.5,
    "width": 11.8,
    "flangeThickness": 2.3,
    "webThickness": 1.28,
    "area": 75.9,
    "weight": 258
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x234",
    "depth": 21.1,
    "width": 11.7,
    "flangeThickness": 2.11,
    "webThickness": 1.16,
    "area": 68.8,
    "weight": 234
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x211",
    "depth": 20.7,
    "width": 11.6,
    "flangeThickness": 1.91,
    "webThickness": 1.06,
    "area": 62.1,
    "weight": 211
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x192",
    "depth": 20.4,
    "width": 11.5,
    "flangeThickness": 1.75,
    "webThickness": 0.96,
    "area": 56.4,
    "weight": 192
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x175",
    "depth": 20,
    "width": 11.4,
    "flangeThickness": 1.59,
    "webThickness": 0.89,
    "area": 51.3,
    "weight": 175
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x158",
    "depth": 19.7,
    "width": 11.3,
    "flangeThickness": 1.44,
    "webThickness": 0.81,
    "area": 46.3,
    "weight": 158
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x143",
    "depth": 19.5,
    "width": 11.2,
    "flangeThickness": 1.32,
    "webThickness": 0.73,
    "area": 42.1,
    "weight": 143
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x130",
    "depth": 19.3,
    "width": 11.2,
    "flangeThickness": 1.2,
    "webThickness": 0.67,
    "area": 38.2,
    "weight": 130
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x119",
    "depth": 19,
    "width": 11.3,
    "flangeThickness": 1.06,
    "webThickness": 0.655,
    "area": 35.1,
    "weight": 119
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x106",
    "depth": 18.7,
    "width": 11.2,
    "flangeThickness": 0.94,
    "webThickness": 0.59,
    "area": 31.1,
    "weight": 106
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x97",
    "depth": 18.6,
    "width": 11.1,
    "flangeThickness": 0.87,
    "webThickness": 0.535,
    "area": 28.5,
    "weight": 97
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x86",
    "depth": 18.4,
    "width": 11.1,
    "flangeThickness": 0.77,
    "webThickness": 0.48,
    "area": 25.3,
    "weight": 86
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x76",
    "depth": 18.2,
    "width": 11,
    "flangeThickness": 0.68,
    "webThickness": 0.425,
    "area": 22.3,
    "weight": 76
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x71",
    "depth": 18.5,
    "width": 7.64,
    "flangeThickness": 0.81,
    "webThickness": 0.495,
    "area": 20.8,
    "weight": 71
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x65",
    "depth": 18.4,
    "width": 7.59,
    "flangeThickness": 0.75,
    "webThickness": 0.45,
    "area": 19.1,
    "weight": 65
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x60",
    "depth": 18.2,
    "width": 7.56,
    "flangeThickness": 0.695,
    "webThickness": 0.415,
    "area": 17.6,
    "weight": 60
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x55",
    "depth": 18.1,
    "width": 7.53,
    "flangeThickness": 0.63,
    "webThickness": 0.39,
    "area": 16.2,
    "weight": 55
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x50",
    "depth": 18,
    "width": 7.5,
    "flangeThickness": 0.57,
    "webThickness": 0.355,
    "area": 14.7,
    "weight": 50
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x46",
    "depth": 18.1,
    "width": 6.06,
    "flangeThickness": 0.605,
    "webThickness": 0.36,
    "area": 13.5,
    "weight": 46
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x40",
    "depth": 17.9,
    "width": 6.02,
    "flangeThickness": 0.525,
    "webThickness": 0.315,
    "area": 11.8,
    "weight": 40
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W18x35",
    "depth": 17.7,
    "width": 6,
    "flangeThickness": 0.425,
    "webThickness": 0.3,
    "area": 10.3,
    "weight": 35
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W16x100",
    "depth": 17,
    "width": 10.4,
    "flangeThickness": 0.985,
    "webThickness": 0.585,
    "area": 29.5,
    "weight": 100
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W16x89",
    "depth": 16.8,
    "width": 10.4,
    "flangeThickness": 0.875,
    "webThickness": 0.525,
    "area": 26.2,
    "weight": 89
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W16x77",
    "depth": 16.5,
    "width": 10.3,
    "flangeThickness": 0.76,
    "webThickness": 0.455,
    "area": 22.6,
    "weight": 77
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W16x67",
    "depth": 16.3,
    "width": 10.2,
    "flangeThickness": 0.665,
    "webThickness": 0.395,
    "area": 19.7,
    "weight": 67
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W16x57",
    "depth": 16.4,
    "width": 7.12,
    "flangeThickness": 0.715,
    "webThickness": 0.43,
    "area": 16.8,
    "weight": 57
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W16x50",
    "depth": 16.3,
    "width": 7.07,
    "flangeThickness": 0.63,
    "webThickness": 0.38,
    "area": 14.7,
    "weight": 50
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W16x45",
    "depth": 16.1,
    "width": 7.04,
    "flangeThickness": 0.565,
    "webThickness": 0.345,
    "area": 13.3,
    "weight": 45
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W16x40",
    "depth": 16,
    "width": 7,
    "flangeThickness": 0.505,
    "webThickness": 0.305,
    "area": 11.8,
    "weight": 40
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W16x36",
    "depth": 15.9,
    "width": 6.99,
    "flangeThickness": 0.43,
    "webThickness": 0.295,
    "area": 10.6,
    "weight": 36
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W16x31",
    "depth": 15.9,
    "width": 5.53,
    "flangeThickness": 0.44,
    "webThickness": 0.275,
    "area": 9.13,
    "weight": 31
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W16x26",
    "depth": 15.7,
    "width": 5.5,
    "flangeThickness": 0.345,
    "webThickness": 0.25,
    "area": 7.68,
    "weight": 26
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x730",
    "depth": 22.4,
    "width": 17.9,
    "flangeThickness": 4.91,
    "webThickness": 3.07,
    "area": 215,
    "weight": 730
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x665",
    "depth": 21.6,
    "width": 17.7,
    "flangeThickness": 4.52,
    "webThickness": 2.83,
    "area": 196,
    "weight": 665
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x605",
    "depth": 20.9,
    "width": 17.4,
    "flangeThickness": 4.16,
    "webThickness": 2.6,
    "area": 178,
    "weight": 605
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x550",
    "depth": 20.2,
    "width": 17.2,
    "flangeThickness": 3.82,
    "webThickness": 2.38,
    "area": 162,
    "weight": 550
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x500",
    "depth": 19.6,
    "width": 17,
    "flangeThickness": 3.5,
    "webThickness": 2.19,
    "area": 147,
    "weight": 500
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x455",
    "depth": 19,
    "width": 16.8,
    "flangeThickness": 3.21,
    "webThickness": 2.02,
    "area": 134,
    "weight": 455
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x426",
    "depth": 18.7,
    "width": 16.7,
    "flangeThickness": 3.04,
    "webThickness": 1.88,
    "area": 125,
    "weight": 426
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x398",
    "depth": 18.3,
    "width": 16.6,
    "flangeThickness": 2.85,
    "webThickness": 1.77,
    "area": 117,
    "weight": 398
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x370",
    "depth": 17.9,
    "width": 16.5,
    "flangeThickness": 2.66,
    "webThickness": 1.66,
    "area": 109,
    "weight": 370
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x342",
    "depth": 17.5,
    "width": 16.4,
    "flangeThickness": 2.47,
    "webThickness": 1.54,
    "area": 101,
    "weight": 342
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x311",
    "depth": 17.1,
    "width": 16.2,
    "flangeThickness": 2.26,
    "webThickness": 1.41,
    "area": 91.4,
    "weight": 311
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x283",
    "depth": 16.7,
    "width": 16.1,
    "flangeThickness": 2.07,
    "webThickness": 1.29,
    "area": 83.3,
    "weight": 283
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x257",
    "depth": 16.4,
    "width": 16,
    "flangeThickness": 1.89,
    "webThickness": 1.18,
    "area": 75.6,
    "weight": 257
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x233",
    "depth": 16,
    "width": 15.9,
    "flangeThickness": 1.72,
    "webThickness": 1.07,
    "area": 68.5,
    "weight": 233
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x211",
    "depth": 15.7,
    "width": 15.8,
    "flangeThickness": 1.56,
    "webThickness": 0.98,
    "area": 62,
    "weight": 211
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x193",
    "depth": 15.5,
    "width": 15.7,
    "flangeThickness": 1.44,
    "webThickness": 0.89,
    "area": 56.8,
    "weight": 193
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x176",
    "depth": 15.2,
    "width": 15.7,
    "flangeThickness": 1.31,
    "webThickness": 0.83,
    "area": 51.8,
    "weight": 176
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x159",
    "depth": 15,
    "width": 15.6,
    "flangeThickness": 1.19,
    "webThickness": 0.745,
    "area": 46.7,
    "weight": 159
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x145",
    "depth": 14.8,
    "width": 15.5,
    "flangeThickness": 1.09,
    "webThickness": 0.68,
    "area": 42.7,
    "weight": 145
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x132",
    "depth": 14.7,
    "width": 14.7,
    "flangeThickness": 1.03,
    "webThickness": 0.645,
    "area": 38.8,
    "weight": 132
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x120",
    "depth": 14.5,
    "width": 14.7,
    "flangeThickness": 0.94,
    "webThickness": 0.59,
    "area": 35.3,
    "weight": 120
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x109",
    "depth": 14.3,
    "width": 14.6,
    "flangeThickness": 0.86,
    "webThickness": 0.525,
    "area": 32,
    "weight": 109
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x99",
    "depth": 14.2,
    "width": 14.6,
    "flangeThickness": 0.78,
    "webThickness": 0.485,
    "area": 29.1,
    "weight": 99
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x90",
    "depth": 14,
    "width": 14.5,
    "flangeThickness": 0.71,
    "webThickness": 0.44,
    "area": 26.5,
    "weight": 90
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x82",
    "depth": 14.3,
    "width": 10.1,
    "flangeThickness": 0.855,
    "webThickness": 0.51,
    "area": 24,
    "weight": 82
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x74",
    "depth": 14.2,
    "width": 10.1,
    "flangeThickness": 0.785,
    "webThickness": 0.45,
    "area": 21.8,
    "weight": 74
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x68",
    "depth": 14,
    "width": 10,
    "flangeThickness": 0.72,
    "webThickness": 0.415,
    "area": 20,
    "weight": 68
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x61",
    "depth": 13.9,
    "width": 10,
    "flangeThickness": 0.645,
    "webThickness": 0.375,
    "area": 17.9,
    "weight": 61
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x53",
    "depth": 13.9,
    "width": 8.06,
    "flangeThickness": 0.66,
    "webThickness": 0.37,
    "area": 15.6,
    "weight": 53
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x48",
    "depth": 13.8,
    "width": 8.03,
    "flangeThickness": 0.595,
    "webThickness": 0.34,
    "area": 14.1,
    "weight": 48
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x43",
    "depth": 13.7,
    "width": 8,
    "flangeThickness": 0.53,
    "webThickness": 0.305,
    "area": 12.6,
    "weight": 43
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x38",
    "depth": 14.1,
    "width": 6.77,
    "flangeThickness": 0.515,
    "webThickness": 0.31,
    "area": 11.2,
    "weight": 38
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x34",
    "depth": 14,
    "width": 6.75,
    "flangeThickness": 0.455,
    "webThickness": 0.285,
    "area": 10,
    "weight": 34
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x30",
    "depth": 13.8,
    "width": 6.73,
    "flangeThickness": 0.385,
    "webThickness": 0.27,
    "area": 8.85,
    "weight": 30
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x26",
    "depth": 13.9,
    "width": 5.03,
    "flangeThickness": 0.42,
    "webThickness": 0.255,
    "area": 7.69,
    "weight": 26
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W14x22",
    "depth": 13.7,
    "width": 5,
    "flangeThickness": 0.335,
    "webThickness": 0.23,
    "area": 6.49,
    "weight": 22
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x336",
    "depth": 16.8,
    "width": 13.4,
    "flangeThickness": 2.96,
    "webThickness": 1.78,
    "area": 98.8,
    "weight": 336
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x305",
    "depth": 16.3,
    "width": 13.2,
    "flangeThickness": 2.71,
    "webThickness": 1.63,
    "area": 89.6,
    "weight": 305
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x279",
    "depth": 15.9,
    "width": 13.1,
    "flangeThickness": 2.47,
    "webThickness": 1.53,
    "area": 81.9,
    "weight": 279
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x252",
    "depth": 15.4,
    "width": 13,
    "flangeThickness": 2.25,
    "webThickness": 1.4,
    "area": 74,
    "weight": 252
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x230",
    "depth": 15.1,
    "width": 12.9,
    "flangeThickness": 2.07,
    "webThickness": 1.29,
    "area": 67.7,
    "weight": 230
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x210",
    "depth": 14.7,
    "width": 12.8,
    "flangeThickness": 1.9,
    "webThickness": 1.18,
    "area": 61.8,
    "weight": 210
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x190",
    "depth": 14.4,
    "width": 12.7,
    "flangeThickness": 1.74,
    "webThickness": 1.06,
    "area": 55.8,
    "weight": 190
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x170",
    "depth": 14,
    "width": 12.6,
    "flangeThickness": 1.56,
    "webThickness": 0.96,
    "area": 50,
    "weight": 170
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x152",
    "depth": 13.7,
    "width": 12.5,
    "flangeThickness": 1.4,
    "webThickness": 0.87,
    "area": 44.7,
    "weight": 152
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x136",
    "depth": 13.4,
    "width": 12.4,
    "flangeThickness": 1.25,
    "webThickness": 0.79,
    "area": 39.9,
    "weight": 136
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x120",
    "depth": 13.1,
    "width": 12.3,
    "flangeThickness": 1.11,
    "webThickness": 0.71,
    "area": 35.3,
    "weight": 120
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x106",
    "depth": 12.9,
    "width": 12.2,
    "flangeThickness": 0.99,
    "webThickness": 0.61,
    "area": 31.2,
    "weight": 106
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x96",
    "depth": 12.7,
    "width": 12.2,
    "flangeThickness": 0.9,
    "webThickness": 0.55,
    "area": 28.2,
    "weight": 96
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x87",
    "depth": 12.5,
    "width": 12.1,
    "flangeThickness": 0.81,
    "webThickness": 0.515,
    "area": 25.6,
    "weight": 87
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x79",
    "depth": 12.4,
    "width": 12.1,
    "flangeThickness": 0.735,
    "webThickness": 0.47,
    "area": 23.2,
    "weight": 79
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x72",
    "depth": 12.3,
    "width": 12,
    "flangeThickness": 0.67,
    "webThickness": 0.43,
    "area": 21.1,
    "weight": 72
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x65",
    "depth": 12.1,
    "width": 12,
    "flangeThickness": 0.605,
    "webThickness": 0.39,
    "area": 19.1,
    "weight": 65
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x58",
    "depth": 12.2,
    "width": 10,
    "flangeThickness": 0.64,
    "webThickness": 0.36,
    "area": 17,
    "weight": 58
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x53",
    "depth": 12.1,
    "width": 10,
    "flangeThickness": 0.575,
    "webThickness": 0.345,
    "area": 15.6,
    "weight": 53
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x50",
    "depth": 12.2,
    "width": 8.08,
    "flangeThickness": 0.64,
    "webThickness": 0.37,
    "area": 14.6,
    "weight": 50
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x45",
    "depth": 12.1,
    "width": 8.05,
    "flangeThickness": 0.575,
    "webThickness": 0.335,
    "area": 13.1,
    "weight": 45
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x40",
    "depth": 11.9,
    "width": 8.01,
    "flangeThickness": 0.515,
    "webThickness": 0.295,
    "area": 11.7,
    "weight": 40
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x35",
    "depth": 12.5,
    "width": 6.56,
    "flangeThickness": 0.52,
    "webThickness": 0.3,
    "area": 10.3,
    "weight": 35
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x30",
    "depth": 12.3,
    "width": 6.52,
    "flangeThickness": 0.44,
    "webThickness": 0.26,
    "area": 8.79,
    "weight": 30
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x26",
    "depth": 12.2,
    "width": 6.49,
    "flangeThickness": 0.38,
    "webThickness": 0.23,
    "area": 7.65,
    "weight": 26
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x22",
    "depth": 12.3,
    "width": 4.03,
    "flangeThickness": 0.425,
    "webThickness": 0.26,
    "area": 6.48,
    "weight": 22
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x19",
    "depth": 12.2,
    "width": 4.01,
    "flangeThickness": 0.35,
    "webThickness": 0.235,
    "area": 5.57,
    "weight": 19
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x16",
    "depth": 12,
    "width": 3.99,
    "flangeThickness": 0.265,
    "webThickness": 0.22,
    "area": 4.71,
    "weight": 16
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W12x14",
    "depth": 11.9,
    "width": 3.97,
    "flangeThickness": 0.225,
    "webThickness": 0.2,
    "area": 4.16,
    "weight": 14
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W10x112",
    "depth": 11.4,
    "width": 10.4,
    "flangeThickness": 1.25,
    "webThickness": 0.755,
    "area": 32.9,
    "weight": 112
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W10x100",
    "depth": 11.1,
    "width": 10.3,
    "flangeThickness": 1.12,
    "webThickness": 0.68,
    "area": 29.4,
    "weight": 100
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W10x88",
    "depth": 10.8,
    "width": 10.3,
    "flangeThickness": 0.99,
    "webThickness": 0.605,
    "area": 25.9,
    "weight": 88
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W10x77",
    "depth": 10.6,
    "width": 10.2,
    "flangeThickness": 0.87,
    "webThickness": 0.53,
    "area": 22.6,
    "weight": 77
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W10x68",
    "depth": 10.4,
    "width": 10.1,
    "flangeThickness": 0.77,
    "webThickness": 0.47,
    "area": 20,
    "weight": 68
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W10x60",
    "depth": 10.2,
    "width": 10.1,
    "flangeThickness": 0.68,
    "webThickness": 0.42,
    "area": 17.6,
    "weight": 60
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W10x54",
    "depth": 10.1,
    "width": 10,
    "flangeThickness": 0.615,
    "webThickness": 0.37,
    "area": 15.8,
    "weight": 54
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W10x49",
    "depth": 10,
    "width": 10,
    "flangeThickness": 0.56,
    "webThickness": 0.34,
    "area": 14.4,
    "weight": 49
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W10x45",
    "depth": 10.1,
    "width": 8.02,
    "flangeThickness": 0.62,
    "webThickness": 0.35,
    "area": 13.3,
    "weight": 45
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W10x39",
    "depth": 9.92,
    "width": 7.99,
    "flangeThickness": 0.53,
    "webThickness": 0.315,
    "area": 11.5,
    "weight": 39
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W10x33",
    "depth": 9.73,
    "width": 7.96,
    "flangeThickness": 0.435,
    "webThickness": 0.29,
    "area": 9.71,
    "weight": 33
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W10x30",
    "depth": 10.5,
    "width": 5.81,
    "flangeThickness": 0.51,
    "webThickness": 0.3,
    "area": 8.84,
    "weight": 30
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W10x26",
    "depth": 10.3,
    "width": 5.77,
    "flangeThickness": 0.44,
    "webThickness": 0.26,
    "area": 7.61,
    "weight": 26
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W10x22",
    "depth": 10.2,
    "width": 5.75,
    "flangeThickness": 0.36,
    "webThickness": 0.24,
    "area": 6.49,
    "weight": 22
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W10x19",
    "depth": 10.2,
    "width": 4.02,
    "flangeThickness": 0.395,
    "webThickness": 0.25,
    "area": 5.62,
    "weight": 19
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W10x17",
    "depth": 10.1,
    "width": 4.01,
    "flangeThickness": 0.33,
    "webThickness": 0.24,
    "area": 4.99,
    "weight": 17
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W10x15",
    "depth": 10,
    "width": 4,
    "flangeThickness": 0.27,
    "webThickness": 0.23,
    "area": 4.41,
    "weight": 15
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W10x12",
    "depth": 9.87,
    "width": 3.96,
    "flangeThickness": 0.21,
    "webThickness": 0.19,
    "area": 3.54,
    "weight": 12
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W8x67",
    "depth": 9,
    "width": 8.28,
    "flangeThickness": 0.935,
    "webThickness": 0.57,
    "area": 19.7,
    "weight": 67
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W8x58",
    "depth": 8.75,
    "width": 8.22,
    "flangeThickness": 0.81,
    "webThickness": 0.51,
    "area": 17.1,
    "weight": 58
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W8x48",
    "depth": 8.5,
    "width": 8.11,
    "flangeThickness": 0.685,
    "webThickness": 0.4,
    "area": 14.1,
    "weight": 48
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W8x40",
    "depth": 8.25,
    "width": 8.07,
    "flangeThickness": 0.56,
    "webThickness": 0.36,
    "area": 11.7,
    "weight": 40
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W8x35",
    "depth": 8.12,
    "width": 8.02,
    "flangeThickness": 0.495,
    "webThickness": 0.31,
    "area": 10.3,
    "weight": 35
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W8x31",
    "depth": 8,
    "width": 8,
    "flangeThickness": 0.435,
    "webThickness": 0.285,
    "area": 9.12,
    "weight": 31
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W8x28",
    "depth": 8.06,
    "width": 6.54,
    "flangeThickness": 0.465,
    "webThickness": 0.285,
    "area": 8.24,
    "weight": 28
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W8x24",
    "depth": 7.93,
    "width": 6.5,
    "flangeThickness": 0.4,
    "webThickness": 0.245,
    "area": 7.08,
    "weight": 24
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W8x21",
    "depth": 8.28,
    "width": 5.27,
    "flangeThickness": 0.4,
    "webThickness": 0.25,
    "area": 6.16,
    "weight": 21
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W8x18",
    "depth": 8.14,
    "width": 5.25,
    "flangeThickness": 0.33,
    "webThickness": 0.23,
    "area": 5.26,
    "weight": 18
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W8x15",
    "depth": 8.11,
    "width": 4.01,
    "flangeThickness": 0.315,
    "webThickness": 0.245,
    "area": 4.44,
    "weight": 15
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W8x13",
    "depth": 7.99,
    "width": 4,
    "flangeThickness": 0.255,
    "webThickness": 0.23,
    "area": 3.84,
    "weight": 13
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W8x10",
    "depth": 7.89,
    "width": 3.94,
    "flangeThickness": 0.205,
    "webThickness": 0.17,
    "area": 2.96,
    "weight": 10
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W6x25",
    "depth": 6.38,
    "width": 6.08,
    "flangeThickness": 0.455,
    "webThickness": 0.32,
    "area": 7.34,
    "weight": 25
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W6x20",
    "depth": 6.2,
    "width": 6.02,
    "flangeThickness": 0.365,
    "webThickness": 0.26,
    "area": 5.87,
    "weight": 20
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W6x15",
    "depth": 5.99,
    "width": 5.99,
    "flangeThickness": 0.26,
    "webThickness": 0.23,
    "area": 4.43,
    "weight": 15
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W6x16",
    "depth": 6.28,
    "width": 4.03,
    "flangeThickness": 0.405,
    "webThickness": 0.26,
    "area": 4.74,
    "weight": 16
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W6x12",
    "depth": 6.03,
    "width": 4,
    "flangeThickness": 0.28,
    "webThickness": 0.23,
    "area": 3.55,
    "weight": 12
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W6x9",
    "depth": 5.9,
    "width": 3.94,
    "flangeThickness": 0.215,
    "webThickness": 0.17,
    "area": 2.68,
    "weight": 9
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W6x8.5",
    "depth": 5.83,
    "width": 3.94,
    "flangeThickness": 0.195,
    "webThickness": 0.17,
    "area": 2.52,
    "weight": 8.5
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W5x19",
    "depth": 5.15,
    "width": 5.03,
    "flangeThickness": 0.43,
    "webThickness": 0.27,
    "area": 5.56,
    "weight": 19
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W5x16",
    "depth": 5.01,
    "width": 5,
    "flangeThickness": 0.36,
    "webThickness": 0.24,
    "area": 4.71,
    "weight": 16
  },
  {
    "kind": "Wide Flange",
    "materialGuid": "6767dd0c-c653-4ea4-b24a-c2a47a499f22",
    "name": "W4x13",
    "depth": 4.16,
    "width": 4.06,
    "flangeThickness": 0.345,
    "webThickness": 0.28,
    "area": 3.83,
    "weight": 13
  }
 ]

const solidRectangularData: Partial<AMemberInfo>[] = [
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 1x1",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 0.75,
    "width": 0.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 1x2",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 1.5,
    "width": 0.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 1x3",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 2.5,
    "width": 0.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 1x4",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 3.5,
    "width": 0.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 1x6",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 5.5,
    "width": 0.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 1x8",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 7.25,
    "width": 0.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 1x10",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 9.25,
    "width": 0.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 1x12",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 11.25,
    "width": 0.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 2x2",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 1.5,
    "width": 1.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 2x3",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 2.5,
    "width": 1.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 2x4",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 3.5,
    "width": 1.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 2x6",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 5.5,
    "width": 1.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 2x8",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 7.25,
    "width": 1.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 2x10",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 9.25,
    "width": 1.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 2x12",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 11.25,
    "width": 1.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 4x4",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 3.5,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 4x6",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 5.5,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 4x8",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 7.25,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 4x10",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 9.25,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Lumber Nominal 6x6",
    "materialGuid": "e7079c05-e5c1-4c2e-a274-9d1fac27463f",
    "depth": 5.5,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 5.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 5.5,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 6\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 6,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 6.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 6.875,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 7.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 7.5,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 8.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 8.25,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 9\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 9.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9.625,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 10.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 10.5,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 11\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 11,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 12\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 12,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 12.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 12.375,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 13.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 13.5,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 13.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 13.75,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 15\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 15,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 15.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 15.125,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 16.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 16.5,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 17.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 17.875,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 18\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 18,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 19.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 19.25,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 19.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 19.5,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 20.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 20.625,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 21\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 21,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 22\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 22,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 2.5\" x 23.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 23.375,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3\" x 5.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 5.5,
    "width": 3
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3\" x 6.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 6.875,
    "width": 3
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3\" x 8.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 8.25,
    "width": 3
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3\" x 9.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9.625,
    "width": 3
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3\" x 11\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 11,
    "width": 3
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3\" x 12.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 12.375,
    "width": 3
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3\" x 13.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 13.75,
    "width": 3
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3\" x 15.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 15.125,
    "width": 3
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3\" x 16.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 16.5,
    "width": 3
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3\" x 17.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 17.875,
    "width": 3
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3\" x 19.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 19.25,
    "width": 3
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3\" x 20.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 20.625,
    "width": 3
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3\" x 22\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 22,
    "width": 3
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3\" x 23.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 23.375,
    "width": 3
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 5.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 5.5,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 6\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 6,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 6.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 6.875,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 7.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 7.5,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 8.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 8.25,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 9\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 9.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9.625,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 10.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 10.5,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 11\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 11,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 12\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 12,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 12.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 12.375,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 13.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 13.5,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 13.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 13.75,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 15\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 15,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 15.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 15.125,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 16.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 16.5,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 17.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 17.875,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 18\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 18,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 19.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 19.25,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 19.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 19.5,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 20.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 20.625,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 21\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 21,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 22\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 22,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 22.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 22.5,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 23.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 23.375,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.125\" x 24\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 24,
    "width": 3.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 5.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 5.5,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 6\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 6,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 6.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 6.875,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 7.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 7.5,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 8.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 8.25,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 9\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 9.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9.25,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 9.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9.5,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 9.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9.625,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 10.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 10.5,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 11.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 11.25,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 11.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 11.875,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 12\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 12,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 12.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 12.375,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 13.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 13.5,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 13.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 13.75,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 14\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 14,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 15\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 15,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 15.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 15.125,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 16\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 16,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 16.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 16.5,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 17.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 17.875,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 18\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 18,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 19.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 19.5,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 20\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 20,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 20.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 20.625,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 21\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 21,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 22\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 22,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 22.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 22.5,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 23.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 23.375,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 3.5\" x 24\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 24,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 6.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 6.875,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 8.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 8.25,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 9.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9.625,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 11\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 11,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 12.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 12.375,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 13.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 13.75,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 15.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 15.125,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 16.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 16.5,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 17.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 17.875,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 19.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 19.25,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 20.675\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 20.675,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 22\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 22,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 23.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 23.375,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 24.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 24.75,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 26.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 26.125,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 27.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 27.5,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 28.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 28.875,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 30.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 30.25,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 31.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 31.625,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 33\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 33,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 34.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 34.375,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5\" x 35.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 35.75,
    "width": 5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 6\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 6,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 6.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 6.875,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 7.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 7.5,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 8.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 8.25,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 9\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 9.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9.625,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 10.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 10.5,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 11\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 11,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 12\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 12,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 12.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 12.375,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 13.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 13.5,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 13.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 13.75,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 15\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 15,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 15.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 15.125,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 16.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 16.5,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 17.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 17.875,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 18\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 18,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 19.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 19.25,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 19.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 19.5,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 20.675\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 20.675,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 21\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 21,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 22\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 22,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 22.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 22.5,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 23.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 23.375,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 24\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 24,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 24.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 24.75,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 25.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 25.5,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 26.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 26.125,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 27\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 27,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 27.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 27.5,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 28.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 28.5,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 28.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 28.875,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 30\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 30,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 30.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 30.25,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 31.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 31.5,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 31.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 31.625,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 33\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 33,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 34.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 34.375,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 34.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 34.5,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 35.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 35.75,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.125\" x 36\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 36,
    "width": 5.125
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 6\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 6,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 6.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 6.875,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 7.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 7.5,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 8.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 8.25,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 9\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 9.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9.25,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 9.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9.5,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 9.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9.625,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 10.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 10.5,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 11\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 11,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 11.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 11.25,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 11.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 11.875,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 12\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 12,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 12.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 12.375,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 13.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 13.5,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 13.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 13.75,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 14\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 14,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 15\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 15,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 15.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 15.125,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 16\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 16,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 16.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 16.5,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 17.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 17.875,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 18\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 18,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 19.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 19.25,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 19.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 19.5,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 20\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 20,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 20.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 20.625,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 21\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 21,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 22\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 22,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 22.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 22.5,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 23.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 23.375,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 24\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 24,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 24.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 24.75,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 25.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 25.5,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 26.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 26.125,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 27\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 27,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 27.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 27.5,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 28.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 28.5,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 28.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 28.875,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 30\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 30,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 30.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 30.25,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 31.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 31.5,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 31.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 31.625,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 33\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 33,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 34.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 34.375,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 34.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 34.5,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 35.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 35.75,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 5.5\" x 36\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 36,
    "width": 5.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 6.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 6.875,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 7.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 7.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 8.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 8.25,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 9\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 9.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9.625,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 10.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 10.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 11\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 11,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 12\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 12,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 12.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 12.375,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 13.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 13.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 13.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 13.75,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 15\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 15,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 15.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 15.125,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 16.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 16.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 17.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 17.875,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 18\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 18,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 19.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 19.25,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 19.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 19.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 20.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 20.625,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 21\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 21,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 22\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 22,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 22.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 22.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 23.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 23.375,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 24\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 24,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 24.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 24.75,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 25.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 25.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 26.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 26.125,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 27\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 27,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 27.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 27.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 28.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 28.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 28.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 28.875,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 30\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 30,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 30.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 30.25,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 31.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 31.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 31.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 31.625,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 33\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 33,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 34.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 34.375,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 34.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 34.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 35.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 35.75,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 36\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 36,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 37.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 37.125,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 37.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 37.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 38.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 38.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 39\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 39,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 39.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 39.875,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 40.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 40.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 41.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 41.25,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 42\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 42,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 42.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 42.625,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 43.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 43.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 44\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 44,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 45\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 45,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 45.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 45.375,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 46.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 46.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 46.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 46.75,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 48\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 48,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 48.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 48.125,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 49.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 49.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 50.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 50.875,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 51\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 51,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 52.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 52.25,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 52.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 52.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 53.675\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 53.675,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 54\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 54,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 55\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 55,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 55.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 55.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 56.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 56.375,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 57\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 57,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 57.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 57.75,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 58.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 58.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 59.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 59.125,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 60\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 60,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 6.75\" x 60.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 60.5,
    "width": 6.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 9.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9.625,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 11\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 11,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 12.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 12.375,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 13.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 13.75,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 15.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 15.125,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 16.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 16.125,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 16.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 16.5,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 18.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 18.875,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 19.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 19.25,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 20.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 20.625,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 22\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 22,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 23.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 23.375,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 24.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 24.75,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 27.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 27.5,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 28.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 28.875,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 30.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 30.25,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 31.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 31.625,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 33\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 33,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 34.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 34.375,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 35.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 35.75,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 37.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 37.125,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 38.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 38.5,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 39.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 39.875,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 41.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 41.25,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 42.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 42.625,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 44\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 44,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 45.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 45.375,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 46.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 46.75,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 48.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 48.125,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 49.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 49.5,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 50.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 50.875,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 52.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 52.25,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 53.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 53.625,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 55\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 55,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 56.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 56.375,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 57.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 57.75,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 59.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 59.125,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.5\" x 60\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 60,
    "width": 8.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 9\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 10.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 10.5,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 12\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 12,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 13.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 13.5,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 15\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 15,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 16.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 16.5,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 18\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 18,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 19.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 19.5,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 21\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 21,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 22.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 22.5,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 24\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 24,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 25.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 25.5,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 27\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 27,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 28.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 28.5,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 30\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 30,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 31.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 31.5,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 33\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 33,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 34.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 34.5,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 36\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 36,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 37.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 37.5,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 39\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 39,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 40.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 40.5,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 42\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 42,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 43.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 43.5,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 45\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 45,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 46.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 46.5,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 48\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 48,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 49.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 49.5,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 51\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 51,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 52.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 52.5,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 54\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 54,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 55.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 55.5,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 57\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 57,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 58.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 58.5,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 8.75\" x 60\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 60,
    "width": 8.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 11\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 11,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 12.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 12.375,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 13.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 13.75,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 15.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 15.125,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 16.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 16.5,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 17.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 17.875,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 19.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 19.25,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 20.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 20.625,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 22\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 22,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 23.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 23.375,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 24.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 24.75,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 26.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 26.125,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 27.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 27.5,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 28.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 28.875,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 30.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 30.25,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 31.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 31.625,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 33\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 33,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 34.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 34.375,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 35.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 35.75,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 37.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 37.125,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 38.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 38.5,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 39.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 39.875,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 41.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 41.25,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 42.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 42.625,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 44\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 44,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 45.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 45.375,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 46.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 46.75,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 48.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 48.125,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 49.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 49.5,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 50.875\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 50.875,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 52.25\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 52.25,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 53.625\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 53.625,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 55\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 55,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 56.375\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 56.375,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 57.75\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 57.75,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 59.125\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 59.125,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.5\" x 60.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 60.5,
    "width": 10.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 6\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 6,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 7.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 7.5,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 9\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 9,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 10.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 10.5,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 12\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 12,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 13.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 13.5,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 15\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 15,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 16.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 16.5,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 18\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 18,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 19.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 19.5,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 21\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 21,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 22.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 22.5,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 24\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 24,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 25.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 25.5,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 27\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 27,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 28.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 28.5,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 30\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 30,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 31.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 31.5,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 33\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 33,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 34.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 34.5,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 36\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 36,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 37.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 37.5,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 39\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 39,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 40.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 40.5,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 42\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 42,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 43.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 43.5,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 45\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 45,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 46.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 46.5,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 48\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 48,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 49.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 49.5,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 51\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 51,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 52.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 52.5,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 54\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 54,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 55.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 55.5,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 57\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 57,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 58.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 58.5,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 10.75\" x 60\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 60,
    "width": 10.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 13.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 13.5,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 15\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 15,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 16.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 16.5,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 18\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 18,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 19.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 19.5,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 21\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 21,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 22.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 22.5,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 24\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 24,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 25.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 25.5,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 27\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 27,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 28.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 28.5,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 30\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 30,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 31.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 31.5,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 33\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 33,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 34.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 34.5,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 36\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 36,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 37.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 37.5,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 39\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 39,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 40.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 40.5,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 42\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 42,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 43.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 43.5,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 45\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 45,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 46.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 46.5,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 48\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 48,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 49.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 49.5,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 51\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 51,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 52.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 52.5,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 54\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 54,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 55.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 55.5,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 57\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 57,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 58.5\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 58.5,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Glue Laminated 12.25\" x 60\"",
    "materialGuid": "59c7e7b9-30b8-4a06-b3c8-7e2462921cf7",
    "depth": 60,
    "width": 12.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 1.5\" x 3.5\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 3.5,
    "width": 1.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 1.5\" x 5.5\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 5.5,
    "width": 1.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 1.5\" x 7.25\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 7.25,
    "width": 1.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 1.5\" x 9.25\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 9.25,
    "width": 1.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 1.5\" x 11.25\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 11.25,
    "width": 1.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 1.75\" x 3.5\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 3.5,
    "width": 1.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 1.75\" x 5.5\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 5.5,
    "width": 1.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 1.75\" x 7.25\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 7.25,
    "width": 1.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 1.75\" x 9.25\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 9.25,
    "width": 1.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 1.75\" x 9.5\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 9.5,
    "width": 1.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 1.75\" x 11.25\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 11.25,
    "width": 1.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 1.75\" x 11.875\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 11.875,
    "width": 1.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 1.75\" x 14\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 14,
    "width": 1.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 1.75\" x 16\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 16,
    "width": 1.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 1.75\" x 18\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 18,
    "width": 1.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 2.5\" x 3.5\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 3.5,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 2.5\" x 5.5\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 5.5,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 2.5\" x 7.25\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 7.25,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 2.5\" x 9.25\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 9.25,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 2.5\" x 11.25\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 11.25,
    "width": 2.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 3.5\" x 3.5\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 3.5,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 3.5\" x 5.5\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 5.5,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 3.5\" x 7.25\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 7.25,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 3.5\" x 9.25\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 9.25,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 3.5\" x 9.5\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 9.5,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 3.5\" x 11.25\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 11.25,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 3.5\" x 11.875\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 11.875,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 3.5\" x 14\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 14,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 3.5\" x 16\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 16,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 3.5\" x 18\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 18,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 3.5\" x 20\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 20,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 3.5\" x 22\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 22,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 3.5\" x 24\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 24,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 5.25\" x 5.5\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 5.5,
    "width": 5.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 5.25\" x 7.25\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 7.25,
    "width": 5.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 5.25\" x 9.5\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 9.5,
    "width": 5.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 5.25\" x 11.875\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 11.875,
    "width": 5.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 5.25\" x 14\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 14,
    "width": 5.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 5.25\" x 16\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 16,
    "width": 5.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 5.25\" x 18\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 18,
    "width": 5.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 5.25\" x 20\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 20,
    "width": 5.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 5.25\" x 22\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 22,
    "width": 5.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 5.25\" x 24\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 24,
    "width": 5.25
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 7\" x 7.25\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 7.25,
    "width": 7
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 7\" x 9.5\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 9.5,
    "width": 7
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 7\" x 11.875\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 11.875,
    "width": 7
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 7\" x 14\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 14,
    "width": 7
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 7\" x 16\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 16,
    "width": 7
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 7\" x 18\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 18,
    "width": 7
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 7\" x 20\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 20,
    "width": 7
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 7\" x 22\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 22,
    "width": 7
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Veneer Lumber (LVL) 7\" x 24\"",
    "materialGuid": "03ca7601-0c2c-4bd4-b55a-b7f6eb19aff4",
    "depth": 24,
    "width": 7
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Strand Lumber (LSL) 1.75\" x 9.5\"",
    "materialGuid": "be2bc758-b03e-499b-a1e7-7a4e805a177e",
    "depth": 9.5,
    "width": 1.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Strand Lumber (LSL) 1.75\" x 11.875\"",
    "materialGuid": "be2bc758-b03e-499b-a1e7-7a4e805a177e",
    "depth": 11.875,
    "width": 1.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Strand Lumber (LSL) 1.75\" x 14\"",
    "materialGuid": "be2bc758-b03e-499b-a1e7-7a4e805a177e",
    "depth": 14,
    "width": 1.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Strand Lumber (LSL) 1.75\" x 16\"",
    "materialGuid": "be2bc758-b03e-499b-a1e7-7a4e805a177e",
    "depth": 16,
    "width": 1.75
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Strand Lumber (LSL) 3.5\" x 3.5\"",
    "materialGuid": "be2bc758-b03e-499b-a1e7-7a4e805a177e",
    "depth": 3.5,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Strand Lumber (LSL) 3.5\" x 4.375\"",
    "materialGuid": "be2bc758-b03e-499b-a1e7-7a4e805a177e",
    "depth": 4.375,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Strand Lumber (LSL) 3.5\" x 5.5\"",
    "materialGuid": "be2bc758-b03e-499b-a1e7-7a4e805a177e",
    "depth": 5.5,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Strand Lumber (LSL) 3.5\" x 7.25\"",
    "materialGuid": "be2bc758-b03e-499b-a1e7-7a4e805a177e",
    "depth": 7.25,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Strand Lumber (LSL) 3.5\" x 9.5\"",
    "materialGuid": "be2bc758-b03e-499b-a1e7-7a4e805a177e",
    "depth": 9.5,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Strand Lumber (LSL) 3.5\" x 11.875\"",
    "materialGuid": "be2bc758-b03e-499b-a1e7-7a4e805a177e",
    "depth": 11.875,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Strand Lumber (LSL) 3.5\" x 14\"",
    "materialGuid": "be2bc758-b03e-499b-a1e7-7a4e805a177e",
    "depth": 14,
    "width": 3.5
  },
  {
    "kind": "Solid Rectangular",
    "name": "Laminated Strand Lumber (LSL) 3.5\" x 16\"",
    "materialGuid": "be2bc758-b03e-499b-a1e7-7a4e805a177e",
    "depth": 16,
    "width": 3.5
  }
 ]

const hollowRectangularData: Partial<AMemberInfo>[] = [
  {
    "kind": "Hollow Rectangular",
    "name": "Rectangular Mullion 2.5 x 6 (Anodized)",
    "materialGuid": "be070326-14ed-4a23-837f-720e3a806952",
    "depth": 6,
    "width": 2.5,
    "thickness": 0.1875
  },
  {
    "kind": "Hollow Rectangular",
    "name": "Rectangular Mullion 2.5 x 7 (Anodized)",
    "materialGuid": "be070326-14ed-4a23-837f-720e3a806952",
    "depth": 7,
    "width": 2.5,
    "thickness": 0.1875
  },
  {
    "kind": "Hollow Rectangular",
    "name": "Rectangular Mullion 2.5 x 6 (Painted)",
    "materialGuid": "415e61a8-adc0-486b-a41d-2f3d66f23404",
    "depth": 6,
    "width": 2.5,
    "thickness": 0.1875
  },
  {
    "kind": "Hollow Rectangular",
    "name": "Rectangular Mullion 2.5 x 7 (Painted)",
    "materialGuid": "415e61a8-adc0-486b-a41d-2f3d66f23404",
    "depth": 7,
    "width": 2.5,
    "thickness": 0.1875
  },
]

const hollowRectangularHSSData: Partial<AMemberInfo>[] = [
  {
    "kind": "Hollow Rectangular",
    "name": "HSS20X12X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 20,
    "width": 12,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS20X12X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 20,
    "width": 12,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS20X12X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 20,
    "width": 12,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS20X12X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 20,
    "width": 12,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS20X8X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 20,
    "width": 8,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS20X8X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 20,
    "width": 8,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS20X8X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 20,
    "width": 8,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS20X8X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 20,
    "width": 8,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS20X4X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 20,
    "width": 4,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS20X4X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 20,
    "width": 4,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS20X4X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 20,
    "width": 4,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS20X4X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 20,
    "width": 4,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS18X6X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 18,
    "width": 6,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS18X6X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 18,
    "width": 6,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS18X6X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 18,
    "width": 6,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS18X6X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 18,
    "width": 6,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS18X6X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 18,
    "width": 6,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS16X16X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "width": 16,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS16X16X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "width": 16,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS16X16X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "width": 16,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS16X16X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "width": 16,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS16X12X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "width": 12,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS16X12X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "width": 12,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS16X12X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "width": 12,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS16X12X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "width": 12,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS16X8X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "width": 8,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS16X8X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "width": 8,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS16X8X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "width": 8,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS16X8X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "width": 8,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS16X8X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "width": 8,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS16X4X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "width": 4,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS16X4X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "width": 4,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS16X4X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "width": 4,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS16X4X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "width": 4,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS16X4X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "width": 4,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS16X4X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 4,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X14X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 14,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X14X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 14,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X14X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 14,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X14X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 14,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X10X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 10,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X10X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 10,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X10X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 10,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X10X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 10,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X10X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 10,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X6X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 10,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X6X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 6,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X6X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 6,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X6X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 6,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X6X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 6,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X6X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 6,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X4X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 4,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X4X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 4,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X4X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 4,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X4X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 4,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X4X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 4,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS14X4X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "width": 4,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X12X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 12,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X12X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 12,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X12X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 12,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X12X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 12,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X12X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 12,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X12X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 12,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X10X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 10,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X10X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 10,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X10X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 10,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X10X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 10,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X8X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 8,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X8X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 8,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X8X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 8,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X8X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 8,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X8X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 8,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X8X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 8,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X6X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 6,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X6X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 6,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X6X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 6,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X6X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 6,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X6X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 6,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X6X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 6,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X4X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 4,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X4X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 4,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X4X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 4,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X4X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 4,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X4X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 4,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X4X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 4,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X3-1/2X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 3.5,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X3-1/2X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 3.5,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X3X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 3,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X3X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 3,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X3X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 3,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X2X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 2,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 2,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS12X2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12,
    "width": 2,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X10X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 10,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X10X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 10,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X10X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 10,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X10X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 10,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X10X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 10,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X10X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 10,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X8X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 8,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X8X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 8,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X8X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 8,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X8X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 8,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X8X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 8,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X8X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 8,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X6X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 6,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X6X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 6,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X6X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 6,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X6X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 6,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X6X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 6,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X6X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 6,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X5X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 5,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X5X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 5,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X5X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X5X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X4X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 4,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X4X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 4,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X4X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 4,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X4X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 4,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X4X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 4,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X4X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 4,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X4X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 4,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X3-1/2X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 3.5,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X3-1/2X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 3.5,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X3-1/2X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 3.5,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X3-1/2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 3.5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X3-1/2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 3.5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X3-1/2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 3.5,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X3X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 3,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X3X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 3,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X3X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 3,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X3X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 3,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X3X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 3,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X2X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 2,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X2X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 2,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 2,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 2,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS10X2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "width": 2,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X9X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 9,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X9X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 9,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X9X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 9,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X9X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 9,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X9X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 9,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X9X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 9,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X9X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 9,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X7X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 7,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X7X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 7,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X7X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 7,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X7X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 7,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X7X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 7,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X7X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 7,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X5X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 5,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X5X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 5,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X5X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 5,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X5X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 5,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X5X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X5X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X3X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 3,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X3X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 3,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X3X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 3,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X3X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 3,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS9X3X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9,
    "width": 3,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X8X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 8,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X8X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 8,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X8X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 8,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X8X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 8,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X8X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 8,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X8X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 8,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X8X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 8,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X6X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 6,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X6X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 6,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X6X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 6,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X6X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 6,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X6X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 6,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X6X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 6,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X4X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 4,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X4X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 4,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X4X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 4,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X4X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 4,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X4X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 4,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X4X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 4,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X4X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 4,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X3X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 3,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X3X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 3,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X3X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 3,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X3X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 3,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X3X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 3,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X3X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 3,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X2X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 2,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X2X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 2,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 2,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 2,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS8X2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8,
    "width": 2,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X7X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 7,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X7X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 7,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X7X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 7,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X7X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 7,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X7X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 7,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X7X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 7,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X7X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 7,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X5X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 5,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X5X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 5,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X5X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 5,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X5X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X5X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X5X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 5,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X4X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 4,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X4X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 4,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X4X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 4,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X4X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 4,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X4X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 4,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X4X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 4,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X3X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 3,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X3X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 3,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X3X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 3,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X3X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 3,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X3X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 3,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X3X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 3,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X2X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 2,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 2,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS7X2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "width": 2,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X6X5/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 6,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X6X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 6,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X6X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 6,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X6X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 6,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X6X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 6,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X6X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 6,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X6X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 6,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X5X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 5,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X5X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 5,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X5X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 5,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X5X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X5X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X5X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 5,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X4X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 4,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X4X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 4,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X4X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 4,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X4X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 4,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X4X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 4,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X4X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 4,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X3X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 3,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X3X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 3,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X3X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 3,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X3X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 3,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X3X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 3,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X3X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 3,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X2X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 2,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X2X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 2,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 2,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 2,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS6X2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "width": 2,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5-1/2X5-1/2X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5.5,
    "width": 5.5,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5-1/2X5-1/2X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5.5,
    "width": 5.5,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5-1/2X5-1/2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5.5,
    "width": 5.5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5-1/2X5-1/2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5.5,
    "width": 5.5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5-1/2X5-1/2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5.5,
    "width": 5.5,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X5X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 5,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X5X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 5,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X5X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 5,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X5X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X5X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X5X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 5,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X4X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 4,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X4X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 4,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X4X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 4,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X4X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 4,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X4X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 4,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X4X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 4,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X3X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 3,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X3X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 3,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X3X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 3,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X3X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 3,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X3X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 3,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X3X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 3,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X2-1/2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 2.5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X2-1/2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 2.5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X2-1/2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 2.5,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X2X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 2,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X2X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 2,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 2,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 2,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS5X2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "width": 2,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4-1/2X4-1/2X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4.5,
    "width": 4.5,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4-1/2X4-1/2X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4.5,
    "width": 4.5,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4-1/2X4-1/2X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4.5,
    "width": 4.5,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4-1/2X4-1/2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4.5,
    "width": 4.5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4-1/2X4-1/2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4.5,
    "width": 4.5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4-1/2X4-1/2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4.5,
    "width": 4.5,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X4X1/2",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 4,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X4X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 4,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X4X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 4,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X4X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 4,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X4X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 4,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X4X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 4,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X3X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 3,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X3X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 3,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X3X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 3,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X3X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 3,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X3X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 3,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X2-1/2X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 2.5,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X2-1/2X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 2.5,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X2-1/2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 2.5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X2-1/2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 2.5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X2-1/2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 2.5,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X2X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 2,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X2X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 2,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 2,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 2,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS4X2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "width": 2,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3-1/2X3-1/2X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3.5,
    "width": 3.5,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3-1/2X3-1/2X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3.5,
    "width": 3.5,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3-1/2X3-1/2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3.5,
    "width": 3.5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3-1/2X3-1/2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3.5,
    "width": 3.5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3-1/2X3-1/2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3.5,
    "width": 3.5,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3-1/2X2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3.5,
    "width": 2,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3-1/2X2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3.5,
    "width": 2,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3-1/2X2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3.5,
    "width": 2,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3-1/2X1-1/2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3.5,
    "width": 1.5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3-1/2X1-1/2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3.5,
    "width": 1.5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3-1/2X1-1/2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3.5,
    "width": 1.5,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3X3X3/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "width": 3,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3X3X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "width": 3,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3X3X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "width": 3,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3X3X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "width": 3,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3X3X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "width": 3,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3X2-1/2X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "width": 2.5,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3X2-1/2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "width": 2.5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3X2-1/2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "width": 2.5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3X2-1/2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "width": 2.5,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3X2X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "width": 2,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3X2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "width": 2,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3X2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "width": 2,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3X2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "width": 2,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3X1-1/2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "width": 1.5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3X1-1/2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "width": 1.5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3X1-1/2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "width": 1.5,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3X1X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "width": 1,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS3X1X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "width": 1,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2-1/2X2-1/2X5/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.5,
    "width": 2.5,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2-1/2X2-1/2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.5,
    "width": 2.5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2-1/2X2-1/2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.5,
    "width": 2.5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2-1/2X2-1/2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.5,
    "width": 2.5,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2-1/2X2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.5,
    "width": 2,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2-1/2X2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.5,
    "width": 2,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2-1/2X2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.5,
    "width": 2,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2-1/2X1-1/2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.5,
    "width": 1.5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2-1/2X1-1/2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.5,
    "width": 1.5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2-1/2X1-1/2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.5,
    "width": 1.5,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2-1/2X1X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.5,
    "width": 1,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2-1/2X1X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.5,
    "width": 1,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2-1/4X2-1/4X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.25,
    "width": 2.25,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2-1/4X2-1/4X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.25,
    "width": 2.25,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2-1/4X2-1/4X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.25,
    "width": 2.25,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2-1/4X2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.25,
    "width": 2.25,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2-1/4X2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.25,
    "width": 2.25,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2X2X1/4",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2,
    "width": 2,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2X2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2,
    "width": 2,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2X2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2,
    "width": 2,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2X1-1/2X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2,
    "width": 1.5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2X1-1/2X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2,
    "width": 1.5,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2X1X3/16",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2,
    "width": 1,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Rectangular",
    "name": "HSS2X1X1/8",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2,
    "width": 1,
    "thickness": 0.116
  }
 ]

const coldFormedData: Partial<AMemberInfo>[] = [
  {
    "kind": "Cold-Formed",
    "name": "2 1/2\" Metal Stud 18ga (250S162-43)",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 2.5,
    "width": 1.625,
    "lip": 0.5,
    "thickness": 0.0451
  },
  {
    "kind": "Cold-Formed",
    "name": "3 5/8\" Metal Stud 18ga (362S162-43)",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 3.625,
    "width": 1.625,
    "lip": 0.5,
    "thickness": 0.0451
  },
  {
    "kind": "Cold-Formed",
    "name": "4\" Metal Stud 18ga (400S162-43)",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 4,
    "width": 1.625,
    "lip": 0.5,
    "thickness": 0.0451
  },
  {
    "kind": "Cold-Formed",
    "name": "6\" Metal Stud 18ga (600S162-43)",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 6,
    "width": 1.625,
    "lip": 0.5,
    "thickness": 0.0451
  },
  {
    "kind": "Cold-Formed",
    "name": "6\" Metal Stud 16ga (600S162-54)",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 6,
    "width": 1.625,
    "lip": 0.5,
    "thickness": 0.0566
  },
  {
    "kind": "Cold-Formed",
    "name": "6\" Metal Stud 14ga (600S200-68)",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 6,
    "width": 2,
    "lip": 0.625,
    "thickness": 0.0713
  },
  {
    "kind": "Cold-Formed",
    "name": "8\" Metal Stud 18ga (800S162-43)",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 8,
    "width": 1.625,
    "lip": 0.5,
    "thickness": 0.0451
  },
  {
    "kind": "Cold-Formed",
    "name": "8\" Metal Stud 16ga (800S162-54)",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 8,
    "width": 1.625,
    "lip": 0.5,
    "thickness": 0.0566
  },
  {
    "kind": "Cold-Formed",
    "name": "8\" Metal Stud 14ga (800S200-68)",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 8,
    "width": 2,
    "lip": 0.625,
    "thickness": 0.0713
  },
  {
    "kind": "Cold-Formed",
    "name": "10\" Metal Stud 18ga (1000S162-43)",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 10,
    "width": 1.625,
    "lip": 0.5,
    "thickness": 0.0451
  },
  {
    "kind": "Cold-Formed",
    "name": "10\" Metal Stud 16ga (1000S162-54)",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 10,
    "width": 1.625,
    "lip": 0.5,
    "thickness": 0.0566
  },
  {
    "kind": "Cold-Formed",
    "name": "12\" Metal Stud 16ga (1200S200-54)",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 12,
    "width": 2,
    "lip": 0.625,
    "thickness": 0.0566
  },
  {
    "kind": "Cold-Formed",
    "name": "12\" Metal Stud 16ga (1200S300-54)",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 12,
    "width": 3,
    "lip": 0.625,
    "thickness": 0.0566
  }
 ]

const metalDeckData: Partial<AMemberInfo>[] = [
  {
    "kind": "Metal Deck",
    "name": "Roof Deck 1.5B 22GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 3.375,
    "bottomFlute": 1.625,
    "depth": 1.5,
    "thickness": 0.0295,
    "width": 6
  },
  {
    "kind": "Metal Deck",
    "name": "Roof Deck 1.5B 20GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 3.375,
    "bottomFlute": 1.625,
    "depth": 1.5,
    "thickness": 0.0358,
    "width": 6
  },
  {
    "kind": "Metal Deck",
    "name": "Roof Deck 1.5B 19GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 3.375,
    "bottomFlute": 1.625,
    "depth": 1.5,
    "thickness": 0.0418,
    "width": 6
  },
  {
    "kind": "Metal Deck",
    "name": "Roof Deck 1.5B 18GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 3.375,
    "bottomFlute": 1.625,
    "depth": 1.5,
    "thickness": 0.0474,
    "width": 6
  },
  {
    "kind": "Metal Deck",
    "name": "Roof Deck 1.5B 16GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 3.375,
    "bottomFlute": 1.625,
    "depth": 1.5,
    "thickness": 0.0598,
    "width": 6
  },
  {
    "kind": "Metal Deck",
    "name": "Roof Deck 3.0NL 22GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 3.625,
    "bottomFlute": 2.0625,
    "depth": 3,
    "thickness": 0.0295,
    "width": 8
  },
  {
    "kind": "Metal Deck",
    "name": "Roof Deck 3.0NL 20GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 3.625,
    "bottomFlute": 2.0625,
    "depth": 3,
    "thickness": 0.0358,
    "width": 8
  },
  {
    "kind": "Metal Deck",
    "name": "Roof Deck 3.0NL 19GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 3.625,
    "bottomFlute": 2.0625,
    "depth": 3,
    "thickness": 0.0418,
    "width": 8
  },
  {
    "kind": "Metal Deck",
    "name": "Roof Deck 3.0NL 18GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 3.625,
    "bottomFlute": 2.0625,
    "depth": 3,
    "thickness": 0.0474,
    "width": 8
  },
  {
    "kind": "Metal Deck",
    "name": "Roof Deck 3.0NL 16GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 3.625,
    "bottomFlute": 2.0625,
    "depth": 3,
    "thickness": 0.0598,
    "width": 8
  },
  {
    "kind": "Metal Deck",
    "name": "Roof Deck Dovetail 2.0DF 20GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 1.75,
    "bottomFlute": 5.25,
    "depth": 2,
    "thickness": 0.0359,
    "width": 6
  },
  {
    "kind": "Metal Deck",
    "name": "Roof Deck Dovetail 2.0DF 18GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 1.75,
    "bottomFlute": 5.25,
    "depth": 2,
    "thickness": 0.0478,
    "width": 6
  },
  {
    "kind": "Metal Deck",
    "name": "Roof Deck Dovetail 2.0DF 16GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 1.75,
    "bottomFlute": 5.25,
    "depth": 2,
    "thickness": 0.0598,
    "width": 6
  },
  {
    "kind": "Metal Deck",
    "name": "Non-Composite Deck 1.0C 26GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 1,
    "bottomFlute": 1.25,
    "depth": 1,
    "thickness": 0.0179,
    "width": 4
  },
  {
    "kind": "Metal Deck",
    "name": "Non-Composite Deck 1.0C 24GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 1,
    "bottomFlute": 1.25,
    "depth": 1,
    "thickness": 0.0239,
    "width": 4
  },
  {
    "kind": "Metal Deck",
    "name": "Non-Composite Deck 1.0C 22GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 1,
    "bottomFlute": 1.25,
    "depth": 1,
    "thickness": 0.0295,
    "width": 4
  },
  {
    "kind": "Metal Deck",
    "name": "Non-Composite Deck 1.0C 20GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 1,
    "bottomFlute": 1.25,
    "depth": 1,
    "thickness": 0.0358,
    "width": 4
  },
  {
    "kind": "Metal Deck",
    "name": "Non-Composite Deck 1.5C 24GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 1.625,
    "bottomFlute": 3.375,
    "depth": 1.5,
    "thickness": 0.0239,
    "width": 6
  },
  {
    "kind": "Metal Deck",
    "name": "Non-Composite Deck 1.5C 22GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 1.625,
    "bottomFlute": 3.375,
    "depth": 1.5,
    "thickness": 0.0295,
    "width": 6
  },
  {
    "kind": "Metal Deck",
    "name": "Non-Composite Deck 1.5C 20GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 1.625,
    "bottomFlute": 3.375,
    "depth": 1.5,
    "thickness": 0.0358,
    "width": 6
  },
  {
    "kind": "Metal Deck",
    "name": "Non-Composite Deck 1.5C 18GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 1.625,
    "bottomFlute": 3.375,
    "depth": 1.5,
    "thickness": 0.0474,
    "width": 6
  },
  {
    "kind": "Metal Deck",
    "name": "Non-Composite Deck 2.0C 22GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 5,
    "bottomFlute": 5,
    "depth": 2,
    "thickness": 0.0295,
    "width": 12
  },
  {
    "kind": "Metal Deck",
    "name": "Non-Composite Deck 2.0C 20GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 5,
    "bottomFlute": 5,
    "depth": 2,
    "thickness": 0.0358,
    "width": 12
  },
  {
    "kind": "Metal Deck",
    "name": "Non-Composite Deck 2.0C 18GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 5,
    "bottomFlute": 5,
    "depth": 2,
    "thickness": 0.0474,
    "width": 12
  },
  {
    "kind": "Metal Deck",
    "name": "Non-Composite Deck 2.0C 16GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 5,
    "bottomFlute": 5,
    "depth": 2,
    "thickness": 0.0598,
    "width": 12
  },
  {
    "kind": "Metal Deck",
    "name": "Non-Composite Deck 3.0C 22GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 4.75,
    "bottomFlute": 4.75,
    "depth": 3,
    "thickness": 0.0295,
    "width": 12
  },
  {
    "kind": "Metal Deck",
    "name": "Non-Composite Deck 3.0C 20GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 4.75,
    "bottomFlute": 4.75,
    "depth": 3,
    "thickness": 0.0358,
    "width": 12
  },
  {
    "kind": "Metal Deck",
    "name": "Non-Composite Deck 3.0C 18GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 4.75,
    "bottomFlute": 4.75,
    "depth": 3,
    "thickness": 0.0474,
    "width": 12
  },
  {
    "kind": "Metal Deck",
    "name": "Non-Composite Deck 3.0C 16GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 4.75,
    "bottomFlute": 4.75,
    "depth": 3,
    "thickness": 0.0598,
    "width": 12
  },
  {
    "kind": "Metal Deck",
    "name": "Composite Deck 1.5VL 22GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 3.375,
    "bottomFlute": 1.625,
    "depth": 1.5,
    "thickness": 0.0295,
    "width": 6
  },
  {
    "kind": "Metal Deck",
    "name": "Composite Deck 1.5VL 20GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 3.375,
    "bottomFlute": 1.625,
    "depth": 1.5,
    "thickness": 0.0358,
    "width": 6
  },
  {
    "kind": "Metal Deck",
    "name": "Composite Deck 1.5VL 19GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 3.375,
    "bottomFlute": 1.625,
    "depth": 1.5,
    "thickness": 0.0418,
    "width": 6
  },
  {
    "kind": "Metal Deck",
    "name": "Composite Deck 1.5VL 18GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 3.375,
    "bottomFlute": 1.625,
    "depth": 1.5,
    "thickness": 0.0474,
    "width": 6
  },
  {
    "kind": "Metal Deck",
    "name": "Composite Deck 1.5VL 16GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 3.375,
    "bottomFlute": 1.625,
    "depth": 1.5,
    "thickness": 0.0598,
    "width": 6
  },
  {
    "kind": "Metal Deck",
    "name": "Composite Deck 2.0VL 22GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 5,
    "bottomFlute": 5,
    "depth": 2,
    "thickness": 0.0295,
    "width": 12
  },
  {
    "kind": "Metal Deck",
    "name": "Composite Deck 2.0VL 20GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 5,
    "bottomFlute": 5,
    "depth": 2,
    "thickness": 0.0358,
    "width": 12
  },
  {
    "kind": "Metal Deck",
    "name": "Composite Deck 2.0VL 19GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 5,
    "bottomFlute": 5,
    "depth": 2,
    "thickness": 0.0418,
    "width": 12
  },
  {
    "kind": "Metal Deck",
    "name": "Composite Deck 2.0VL 18GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 5,
    "bottomFlute": 5,
    "depth": 2,
    "thickness": 0.0474,
    "width": 12
  },
  {
    "kind": "Metal Deck",
    "name": "Composite Deck 2.0VL 16GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 5,
    "bottomFlute": 5,
    "depth": 2,
    "thickness": 0.0598,
    "width": 12
  },
  {
    "kind": "Metal Deck",
    "name": "Composite Deck 3.0VL 22GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 4.75,
    "bottomFlute": 4.75,
    "depth": 3,
    "thickness": 0.0295,
    "width": 12
  },
  {
    "kind": "Metal Deck",
    "name": "Composite Deck 3.0VL 20GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 4.75,
    "bottomFlute": 4.75,
    "depth": 3,
    "thickness": 0.0358,
    "width": 12
  },
  {
    "kind": "Metal Deck",
    "name": "Composite Deck 3.0VL 19GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 4.75,
    "bottomFlute": 4.75,
    "depth": 3,
    "thickness": 0.0418,
    "width": 12
  },
  {
    "kind": "Metal Deck",
    "name": "Composite Deck 3.0VL 18GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 4.75,
    "bottomFlute": 4.75,
    "depth": 3,
    "thickness": 0.0474,
    "width": 12
  },
  {
    "kind": "Metal Deck",
    "name": "Composite Deck 3.0VL 16GA",
    "materialGuid": "04409462-8d84-42f6-b996-233f59673a9c",
    "topFlute": 4.75,
    "bottomFlute": 4.75,
    "depth": 3,
    "thickness": 0.0598,
    "width": 12
  }
 ]

const rebarData: Partial<AMemberInfo>[] = [
  {
    "kind": "Solid Round",
    "name": "Steel Rebar #3",
    "materialGuid": "737b4a66-4213-4e75-b5c2-3114b6e04028",
    "depth": 0.375
  },
  {
    "kind": "Solid Round",
    "name": "Steel Rebar #4",
    "materialGuid": "737b4a66-4213-4e75-b5c2-3114b6e04028",
    "depth": 0.5
  },
  {
    "kind": "Solid Round",
    "name": "Steel Rebar #5",
    "materialGuid": "737b4a66-4213-4e75-b5c2-3114b6e04028",
    "depth": 0.625
  },
  {
    "kind": "Solid Round",
    "name": "Steel Rebar #6",
    "materialGuid": "737b4a66-4213-4e75-b5c2-3114b6e04028",
    "depth": 0.75
  },
  {
    "kind": "Solid Round",
    "name": "Steel Rebar #7",
    "materialGuid": "737b4a66-4213-4e75-b5c2-3114b6e04028",
    "depth": 0.875
  },
  {
    "kind": "Solid Round",
    "name": "Steel Rebar #8",
    "materialGuid": "737b4a66-4213-4e75-b5c2-3114b6e04028",
    "depth": 1
  },
  {
    "kind": "Solid Round",
    "name": "Steel Rebar #9",
    "materialGuid": "737b4a66-4213-4e75-b5c2-3114b6e04028",
    "depth": 1.125
  },
  {
    "kind": "Solid Round",
    "name": "Steel Rebar #10",
    "materialGuid": "737b4a66-4213-4e75-b5c2-3114b6e04028",
    "depth": 1.25
  },
  {
    "kind": "Solid Round",
    "name": "Steel Rebar #11",
    "materialGuid": "737b4a66-4213-4e75-b5c2-3114b6e04028",
    "depth": 1.375
  },
  {
    "kind": "Solid Round",
    "name": "Steel Rebar #14",
    "materialGuid": "737b4a66-4213-4e75-b5c2-3114b6e04028",
    "depth": 1.75
  },
  {
    "kind": "Solid Round",
    "name": "Steel Rebar #18",
    "materialGuid": "737b4a66-4213-4e75-b5c2-3114b6e04028",
    "depth": 2.25
  }
 ]

const roundHollowHSSData: Partial<AMemberInfo>[] = [
  {
    "kind": "Hollow Round",
    "name": "HSS20X0.500",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 20,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Round",
    "name": "HSS20X0.375",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 20,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Round",
    "name": "HSS18X0.500",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 18,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Round",
    "name": "HSS18X0.375",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 18,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Round",
    "name": "HSS16X0.625",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Round",
    "name": "HSS16X0.500",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Round",
    "name": "HSS16X0.438",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "thickness": 0.407
  },
  {
    "kind": "Hollow Round",
    "name": "HSS16X0.375",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Round",
    "name": "HSS16X0.312",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Round",
    "name": "HSS16X0.250",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 16,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Round",
    "name": "HSS14X0.625",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Round",
    "name": "HSS14X0.500",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Round",
    "name": "HSS14X0.375",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Round",
    "name": "HSS14X0.312",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Round",
    "name": "HSS14X0.250",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 14,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Round",
    "name": "HSS12.750X0.500",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12.75,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Round",
    "name": "HSS12.750X0.375",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12.75,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Round",
    "name": "HSS12.750X0.250",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 12.75,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Round",
    "name": "HSS10.750X0.500",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10.75,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Round",
    "name": "HSS10.750X0.375",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10.75,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Round",
    "name": "HSS10.750X0.250",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10.75,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Round",
    "name": "HSS10X0.625",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Round",
    "name": "HSS10X0.500",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Round",
    "name": "HSS10X0.375",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Round",
    "name": "HSS10X0.312",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Round",
    "name": "HSS10X0.250",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Round",
    "name": "HSS10X0.188",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 10,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Round",
    "name": "HSS9.625X0.500",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9.625,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Round",
    "name": "HSS9.625X0.375",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9.625,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Round",
    "name": "HSS9.625X0.312",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9.625,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Round",
    "name": "HSS9.625X0.250",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9.625,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Round",
    "name": "HSS9.625X0.188",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 9.625,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Round",
    "name": "HSS8.625X0.625",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8.625,
    "thickness": 0.581
  },
  {
    "kind": "Hollow Round",
    "name": "HSS8.625X0.500",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8.625,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Round",
    "name": "HSS8.625X0.375",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8.625,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Round",
    "name": "HSS8.625X0.322",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8.625,
    "thickness": 0.3
  },
  {
    "kind": "Hollow Round",
    "name": "HSS8.625X0.250",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8.625,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Round",
    "name": "HSS8.625X0.188",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8.625,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Round",
    "name": "HSS7.625X0.375",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8.625,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Round",
    "name": "HSS7.625X0.328",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 8.625,
    "thickness": 0.305
  },
  {
    "kind": "Hollow Round",
    "name": "HSS7.500X0.500",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7.5,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Round",
    "name": "HSS7.500X0.375",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7.5,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Round",
    "name": "HSS7.500X0.312",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7.5,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Round",
    "name": "HSS7.500X0.250",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7.5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Round",
    "name": "HSS7.500X0.188",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7.5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Round",
    "name": "HSS7X0.500",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Round",
    "name": "HSS7X0.375",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Round",
    "name": "HSS7X0.312",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Round",
    "name": "HSS7X0.250",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Round",
    "name": "HSS7X0.188",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Round",
    "name": "HSS7X0.125",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 7,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6.875X0.500",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6.875,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6.875X0.375",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6.875,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6.875X0.312",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6.875,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6.875X0.250",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6.875,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6.875X0.188",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6.875,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6.625X0.500",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6.625,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6.625X0.432",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6.625,
    "thickness": 0.402
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6.625X0.375",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6.625,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6.625X0.312",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6.625,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6.625X0.280",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6.625,
    "thickness": 0.26
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6.625X0.250",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6.625,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6.625X0.188",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6.625,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6.625X0.125",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6.625,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6X0.500",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6X0.375",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6X0.312",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6X0.280",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "thickness": 0.26
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6X0.250",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6X0.188",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Round",
    "name": "HSS6X0.125",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 6,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Round",
    "name": "HSS5.563X0.500",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5.563,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Round",
    "name": "HSS5.563X0.375",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5.563,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Round",
    "name": "HSS5.563X0.258",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5.563,
    "thickness": 0.24
  },
  {
    "kind": "Hollow Round",
    "name": "HSS5.563X0.188",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5.563,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Round",
    "name": "HSS5.563X0.134",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5.563,
    "thickness": 0.124
  },
  {
    "kind": "Hollow Round",
    "name": "HSS5.500X0.500",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5.5,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Round",
    "name": "HSS5.500X0.375",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5.5,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Round",
    "name": "HSS5.500X0.258",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5.5,
    "thickness": 0.24
  },
  {
    "kind": "Hollow Round",
    "name": "HSS5X0.500",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "thickness": 0.465
  },
  {
    "kind": "Hollow Round",
    "name": "HSS5X0.375",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Round",
    "name": "HSS5X0.312",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Round",
    "name": "HSS5X0.258",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "thickness": 0.24
  },
  {
    "kind": "Hollow Round",
    "name": "HSS5X0.250",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Round",
    "name": "HSS5X0.188",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Round",
    "name": "HSS5X0.125",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 5,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Round",
    "name": "HSS4.500X0.375",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4.5,
    "thickness": 0.349
  },
  {
    "kind": "Hollow Round",
    "name": "HSS4.500X0.337",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4.5,
    "thickness": 0.313
  },
  {
    "kind": "Hollow Round",
    "name": "HSS4.500X0.237",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4.5,
    "thickness": 0.22
  },
  {
    "kind": "Hollow Round",
    "name": "HSS4.500X0.188",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4.5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Round",
    "name": "HSS4.500X0.125",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4.5,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Round",
    "name": "HSS4X0.313",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Round",
    "name": "HSS4X0.250",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Round",
    "name": "HSS4X0.237",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "thickness": 0.22
  },
  {
    "kind": "Hollow Round",
    "name": "HSS4X0.226",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "thickness": 0.21
  },
  {
    "kind": "Hollow Round",
    "name": "HSS4X0.220",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "thickness": 0.205
  },
  {
    "kind": "Hollow Round",
    "name": "HSS4X0.188",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Round",
    "name": "HSS4X0.125",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 4,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Round",
    "name": "HSS3.500X0.313",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3.5,
    "thickness": 0.291
  },
  {
    "kind": "Hollow Round",
    "name": "HSS3.500X0.300",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3.5,
    "thickness": 0.279
  },
  {
    "kind": "Hollow Round",
    "name": "HSS3.500X0.250",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3.5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Round",
    "name": "HSS3.500X0.216",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3.5,
    "thickness": 0.201
  },
  {
    "kind": "Hollow Round",
    "name": "HSS3.500X0.203",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3.5,
    "thickness": 0.189
  },
  {
    "kind": "Hollow Round",
    "name": "HSS3.500X0.188",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3.5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Round",
    "name": "HSS3.500X0.125",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3.5,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Round",
    "name": "HSS3X0.250",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Round",
    "name": "HSS3X0.216",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "thickness": 0.201
  },
  {
    "kind": "Hollow Round",
    "name": "HSS3X0.203",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "thickness": 0.189
  },
  {
    "kind": "Hollow Round",
    "name": "HSS3X0.188",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Round",
    "name": "HSS3X0.152",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "thickness": 0.141
  },
  {
    "kind": "Hollow Round",
    "name": "HSS3X0.134",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "thickness": 0.124
  },
  {
    "kind": "Hollow Round",
    "name": "HSS3X0.125",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 3,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Round",
    "name": "HSS2.875X0.250",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.875,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Round",
    "name": "HSS2.875X0.203",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.875,
    "thickness": 0.189
  },
  {
    "kind": "Hollow Round",
    "name": "HSS2.875X0.188",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.875,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Round",
    "name": "HSS2.875X0.125",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.875,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Round",
    "name": "HSS2.500X0.250",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.5,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Round",
    "name": "HSS2.500X0.188",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.5,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Round",
    "name": "HSS2.500X0.125",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.5,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Round",
    "name": "HSS2.375X0.250",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.375,
    "thickness": 0.233
  },
  {
    "kind": "Hollow Round",
    "name": "HSS2.375X0.218",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.375,
    "thickness": 0.203
  },
  {
    "kind": "Hollow Round",
    "name": "HSS2.375X0.188",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.375,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Round",
    "name": "HSS2.375X0.154",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.375,
    "thickness": 0.143
  },
  {
    "kind": "Hollow Round",
    "name": "HSS2.375X0.125",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 2.375,
    "thickness": 0.116
  },
  {
    "kind": "Hollow Round",
    "name": "HSS1.900X0.188",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 1.9,
    "thickness": 0.174
  },
  {
    "kind": "Hollow Round",
    "name": "HSS1.900X0.145",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 1.9,
    "thickness": 0.135
  },
  {
    "kind": "Hollow Round",
    "name": "HSS1.900X0.120",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 1.9,
    "thickness": 0.111
  },
  {
    "kind": "Hollow Round",
    "name": "HSS1.660X0.140",
    "materialGuid": "c6ba4bd0-78bf-4b8a-abb1-7b464a171bec",
    "depth": 1.66,
    "thickness": 0.13
  }
 ]

const zeeData: Partial<AMemberInfo>[] = [
  {
    "kind": "Zee",
    "name": "Z-Girt 150ZG-33",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 1.5,
    "width": 3.5,
    "thickness": 0.0346
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 150ZG-43",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 1.5,
    "width": 3.5,
    "thickness": 0.0451
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 150ZG-54",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 1.5,
    "width": 3.5,
    "thickness": 0.0566
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 150ZG-68",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 1.5,
    "width": 3.5,
    "thickness": 0.0713
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 200ZG-33",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 2,
    "width": 3.5,
    "thickness": 0.0346
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 200ZG-43",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 2,
    "width": 3.5,
    "thickness": 0.0451
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 200ZG-54",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 2,
    "width": 3.5,
    "thickness": 0.0566
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 200ZG-68",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 2,
    "width": 3.5,
    "thickness": 0.0713
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 250ZG-33",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 2.5,
    "width": 3.5,
    "thickness": 0.0346
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 250ZG-43",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 2.5,
    "width": 3.5,
    "thickness": 0.0451
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 250ZG-54",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 2.5,
    "width": 3.5,
    "thickness": 0.0566
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 250ZG-68",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 2.5,
    "width": 3.5,
    "thickness": 0.0713
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 300ZG-33",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 3,
    "width": 3.5,
    "thickness": 0.0346
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 300ZG-43",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 3,
    "width": 3.5,
    "thickness": 0.0451
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 300ZG-54",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 3,
    "width": 3.5,
    "thickness": 0.0566
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 300ZG-68",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 3,
    "width": 3.5,
    "thickness": 0.0713
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 350ZG-33",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 3.5,
    "width": 3.5,
    "thickness": 0.0346
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 350ZG-43",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 3.5,
    "width": 3.5,
    "thickness": 0.0451
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 350ZG-54",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 3.5,
    "width": 3.5,
    "thickness": 0.0566
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 350ZG-68",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 3.5,
    "width": 3.5,
    "thickness": 0.0713
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 400ZG-33",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 4,
    "width": 3.5,
    "thickness": 0.0346
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 400ZG-43",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 4,
    "width": 3.5,
    "thickness": 0.0451
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 400ZG-54",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 4,
    "width": 3.5,
    "thickness": 0.0566
  },
  {
    "kind": "Zee",
    "name": "Z-Girt 400ZG-68",
    "materialGuid": "8eefbc45-bcb2-42dc-9f60-7fdda5b9a2e8",
    "depth": 4,
    "width": 3.5,
    "thickness": 0.0713
  }
 ]